!(function () {
  var e = {
      592: function (e, t, n) {
        e.exports = (function () {
          function e(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          function t(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function r(n) {
            for (var r = 1; r < arguments.length; r++) {
              var i = null != arguments[r] ? arguments[r] : {};
              r % 2
                ? t(Object(i), !0).forEach(function (t) {
                    e(n, t, i[t]);
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    n,
                    Object.getOwnPropertyDescriptors(i)
                  )
                : t(Object(i)).forEach(function (e) {
                    Object.defineProperty(
                      n,
                      e,
                      Object.getOwnPropertyDescriptor(i, e)
                    );
                  });
            }
            return n;
          }
          function i(e) {
            var t = { exports: {} };
            return e(t, t.exports), t.exports;
          }
          "undefined" != typeof globalThis
            ? globalThis
            : "undefined" != typeof window
            ? window
            : void 0 !== n.g
            ? n.g
            : "undefined" != typeof self && self;
          var o = i(function (e, t) {
            !(function (t, n) {
              e.exports = n();
            })(0, function () {
              var e =
                /^v?(?:\d+)(\.(?:[x*]|\d+)(\.(?:[x*]|\d+)(\.(?:[x*]|\d+))?(?:-[\da-z\-]+(?:\.[\da-z\-]+)*)?(?:\+[\da-z\-]+(?:\.[\da-z\-]+)*)?)?)?$/i;
              function t(e, t) {
                return -1 === e.indexOf(t) ? e.length : e.indexOf(t);
              }
              function n(e) {
                var n = e.replace(/^v/, "").replace(/\+.*$/, ""),
                  r = t(n, "-"),
                  i = n.substring(0, r).split(".");
                return i.push(n.substring(r + 1)), i;
              }
              function r(e) {
                return isNaN(Number(e)) ? e : Number(e);
              }
              function i(t) {
                if ("string" != typeof t)
                  throw new TypeError("Invalid argument expected string");
                if (!e.test(t))
                  throw new Error(
                    "Invalid argument not valid semver ('" + t + "' received)"
                  );
              }
              function o(e, t) {
                [e, t].forEach(i);
                for (
                  var o = n(e), s = n(t), a = 0;
                  a < Math.max(o.length - 1, s.length - 1);
                  a++
                ) {
                  var c = parseInt(o[a] || 0, 10),
                    l = parseInt(s[a] || 0, 10);
                  if (c > l) return 1;
                  if (l > c) return -1;
                }
                var u = o[o.length - 1],
                  d = s[s.length - 1];
                if (u && d) {
                  var h = u.split(".").map(r),
                    f = d.split(".").map(r);
                  for (a = 0; a < Math.max(h.length, f.length); a++) {
                    if (
                      void 0 === h[a] ||
                      ("string" == typeof f[a] && "number" == typeof h[a])
                    )
                      return -1;
                    if (
                      void 0 === f[a] ||
                      ("string" == typeof h[a] && "number" == typeof f[a])
                    )
                      return 1;
                    if (h[a] > f[a]) return 1;
                    if (f[a] > h[a]) return -1;
                  }
                } else if (u || d) return u ? -1 : 1;
                return 0;
              }
              var s = [">", ">=", "=", "<", "<="],
                a = {
                  ">": [1],
                  ">=": [0, 1],
                  "=": [0],
                  "<=": [-1, 0],
                  "<": [-1],
                };
              function c(e) {
                if ("string" != typeof e)
                  throw new TypeError(
                    "Invalid operator type, expected string but got " + typeof e
                  );
                if (-1 === s.indexOf(e))
                  throw new TypeError(
                    "Invalid operator, expected one of " + s.join("|")
                  );
              }
              return (
                (o.validate = function (t) {
                  return "string" == typeof t && e.test(t);
                }),
                (o.compare = function (e, t, n) {
                  c(n);
                  var r = o(e, t);
                  return a[n].indexOf(r) > -1;
                }),
                o
              );
            });
          });
          const s = (e) => null == e,
            a = (e) => Object.getPrototypeOf(e) === Object.prototype,
            c = (e) => Array.isArray(e),
            l = (e) => {
              let t = {};
              return (
                Object.entries(e)
                  .filter(([e, t]) => "function" == typeof t)
                  .forEach(([e, n]) => (t[e] = n)),
                t
              );
            },
            u = () =>
              navigator.userAgent.includes("Node.js") ||
              navigator.userAgent.includes("jsdom"),
            d = () =>
              !!u() ||
              (!!window.Alpine &&
                o.compare(window.Alpine.version, "2.7.0", ">=")),
            h = (e, t) => (
              Object.entries(e).forEach(([n, r]) => {
                s(r) || (!a(r) && !c(r)) || (e[n] = h(r, t));
              }),
              new Proxy(e, {
                get: (e, n, r) => t.get(e, n, r),
                set(e, n, r, i) {
                  s(r) || (!a(r) && !c(r)) || (r = h(r, t));
                  let o = e[n];
                  return (
                    (e[n] = r),
                    s(o) || s(o.__watchers) || (e[n].__watchers = o.__watchers),
                    t.set(e, n, e[n], i),
                    !0
                  );
                },
              })
            ),
            f = {
              stores: {},
              persistenceDriver: window.localStorage,
              persisted: [],
              persistedDrivers: {},
              subscribers: [],
              pendingWatchers: {},
              disableReactivity: !1,
              startingCallbacks: [],
              startedCallbacks: [],
              hasStarted: !1,
              start() {
                this.startingCallbacks.forEach((e) => e()),
                  this.attach(),
                  (this.stores = h(this.stores, {
                    get: (e, t, n) =>
                      Object.is(n, this.stores) &&
                      ["get", "set", "toggle", "call", "clear"].includes(t)
                        ? this[t].bind(this)
                        : Reflect.get(e, t, n),
                    set: (e, t, n, r) => {
                      if (!this.disableReactivity) {
                        this.updateSubscribers(),
                          this.runWatchers(e, t, n, r),
                          (this.disableReactivity = !0);
                        try {
                          this.persisted.forEach(
                            this.updateLocalStorage.bind(this)
                          );
                        } catch (e) {}
                        this.disableReactivity = !1;
                      }
                    },
                  })),
                  (this.hasStarted = !0),
                  (this.disableReactivity = !0),
                  Object.entries(this.pendingWatchers).forEach(([e, t]) => {
                    t.forEach((t) => this.watch(e, t));
                  }),
                  (this.disableReactivity = !1),
                  this.startedCallbacks.forEach((e) => e());
              },
              starting(e) {
                this.startingCallbacks.push(e);
              },
              started(e) {
                this.startedCallbacks.push(e);
              },
              attach() {
                if (!d())
                  throw new Error(
                    "[Spruce] You must be using Alpine >= 2.5.0 to use Spruce."
                  );
                const e = this;
                window.Alpine.addMagicProperty(
                  "store",
                  (t) => (e.subscribe(t), e.stores)
                );
              },
              store(e, t, n = !1) {
                "function" == typeof t && (t = t());
                const r = this.isValidDriver(n);
                if (!0 === n || r)
                  try {
                    (this.stores[e] = this.retrieveFromLocalStorage(
                      e,
                      l(t),
                      r ? n : void 0
                    )),
                      r && (this.persistedDrivers[e] = n),
                      this.persisted.includes(e) || this.persisted.push(e);
                  } catch (e) {}
                return this.stores[e] || (this.stores[e] = t), this.stores[e];
              },
              reset(e, t) {
                void 0 !== this.stores[e] && (this.stores[e] = t);
              },
              delete(e, t = !0) {
                return (
                  void 0 !== this.stores[e] &&
                  (delete this.stores[e], t && this.updateSubscribers(), !0)
                );
              },
              deleteAll() {
                const e = Object.keys(this.stores).map((e) =>
                  this.delete(e, !1)
                );
                return this.updateSubscribers(), !e.some((e) => !e);
              },
              subscribe(e) {
                return (
                  this.subscribers.includes(e) || this.subscribers.push(e),
                  this.stores
                );
              },
              updateSubscribers() {
                this.subscribers
                  .filter((e) => !!e.__x)
                  .forEach((e) => {
                    e.__x.updateElements(e);
                  });
              },
              retrieveFromLocalStorage(e, t = {}, n) {
                let r = this.persistenceDriver;
                void 0 !== n && (this.guardAgainstInvalidDrivers(n), (r = n));
                const i = r.getItem(`__spruce:${e}`);
                if (!i) return null;
                let o = JSON.parse(i);
                return (
                  "object" == typeof o &&
                    ((o = Object.assign(t, o)),
                    delete o.__watchers,
                    delete o.__key_name),
                  o
                );
              },
              updateLocalStorage(e) {
                const t = r({}, this.store(e));
                delete t.__watchers,
                  delete t.__key_name,
                  (this.persistedDrivers[e] || this.persistenceDriver).setItem(
                    `__spruce:${e}`,
                    JSON.stringify(this.store(e))
                  );
              },
              get(e, t = this.stores) {
                return e.split(".").reduce((e, t) => e[t], t);
              },
              set(e, t, n = this.stores) {
                return (
                  c(e) || (e = e.split(".")),
                  1 === e.length
                    ? (n[e[0]] = t)
                    : (n[e[0]] || (n[e[0]] = {}),
                      this.set(e.slice(1), t, n[e[0]]))
                );
              },
              toggle(e) {
                return this.set(e, !this.get(e));
              },
              call(e, ...t) {
                return this.get(e)(...t);
              },
              clear(e) {
                return this.persistenceDriver.removeItem(`__spruce:${e}`);
              },
              watch(e, t) {
                if (!this.hasStarted)
                  return (
                    this.pendingWatchers[e] || (this.pendingWatchers[e] = []),
                    this.pendingWatchers[e].push(t),
                    [() => this.unwatch(e, t)]
                  );
                const n = e.split("."),
                  r = n.reduce((e, t) => {
                    const n = e[t];
                    return s(n) || (!a(n) && !c(n)) ? e : n;
                  }, this.stores),
                  i = Object.is(r, this.get(e)) ? "__self" : n[n.length - 1];
                return (
                  r.hasOwnProperty("__watchers") ||
                    Object.defineProperty(r, "__watchers", {
                      enumerable: !1,
                      value: new Map(),
                      configurable: !0,
                    }),
                  r.__watchers.has(i) || r.__watchers.set(i, new Set()),
                  r.__watchers.get(i).add(t),
                  [() => this.unwatch(e, t)]
                );
              },
              unwatch(e, t) {
                const n = e.split("."),
                  r = n.reduce((e, t) => {
                    const n = e[t];
                    return s(n) || (!a(n) && !c(n)) ? e : n;
                  }, this.stores),
                  i = Object.is(r, this.get(e)) ? "__self" : n[n.length - 1],
                  o = r.__watchers;
                o.has(i) && o.get(i).delete(t);
              },
              watchers(e) {
                const t = e.split("."),
                  n = t.reduce((e, t) => {
                    const n = e[t];
                    return s(n) || (!a(n) && !c(n)) ? e : n;
                  }, this.stores),
                  r = Object.is(n, this.get(e)) ? "__self" : t[t.length - 1];
                return n.__watchers ? n.__watchers.get(r) : {};
              },
              runWatchers(e, t, n) {
                e.__watchers &&
                  (e.__watchers.has(t) &&
                    e.__watchers.get(t).forEach((e) => e(n)),
                  e.__watchers.has("__self") &&
                    e.__watchers.get("__self").forEach((e) => e(n, t)));
              },
              persistUsing(e) {
                this.persisted.length > 0 &&
                  console.warn(
                    "[Spruce] You have already initialised a persisted store. Changing the driver may cause issues."
                  ),
                  this.guardAgainstInvalidDrivers(e),
                  (this.persistenceDriver = e);
              },
              guardAgainstInvalidDrivers(e) {
                if ("function" != typeof e.getItem)
                  throw new Error(
                    "[Spruce] The persistence driver must have a `getItem(key)` method."
                  );
                if ("function" != typeof e.setItem)
                  throw new Error(
                    "[Spruce] The persistence driver must have a `setItem(key, value)` method."
                  );
                if ("function" != typeof e.removeItem)
                  throw new Error(
                    "[Spruce] The persistence driver must have a `removeItem(name)` method."
                  );
              },
              isValidDriver(e) {
                try {
                  this.guardAgainstInvalidDrivers(e);
                } catch (e) {
                  return !1;
                }
                return !0;
              },
            };
          window.Spruce = f;
          const p =
            window.deferLoadingAlpine ||
            function (e) {
              e();
            };
          return (
            (window.deferLoadingAlpine = function (e) {
              window.Spruce.start(), p(e);
            }),
            f
          );
        })();
      },
      443: function (e) {
        e.exports = (function () {
          "use strict";
          function e(e, t, n) {
            return (
              t in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          function t(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t &&
                (r = r.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, r);
            }
            return n;
          }
          function n(n) {
            for (var r = 1; r < arguments.length; r++) {
              var i = null != arguments[r] ? arguments[r] : {};
              r % 2
                ? t(Object(i), !0).forEach(function (t) {
                    e(n, t, i[t]);
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    n,
                    Object.getOwnPropertyDescriptors(i)
                  )
                : t(Object(i)).forEach(function (e) {
                    Object.defineProperty(
                      n,
                      e,
                      Object.getOwnPropertyDescriptor(i, e)
                    );
                  });
            }
            return n;
          }
          function r() {
            return new Promise((e) => {
              "loading" == document.readyState
                ? document.addEventListener("DOMContentLoaded", e)
                : e();
            });
          }
          function i(e) {
            return Array.from(new Set(e));
          }
          function o() {
            return (
              navigator.userAgent.includes("Node.js") ||
              navigator.userAgent.includes("jsdom")
            );
          }
          function s(e, t) {
            return e == t;
          }
          function a(e, t) {
            "template" !== e.tagName.toLowerCase()
              ? console.warn(
                  `Alpine: [${t}] directive should only be added to <template> tags. See https://github.com/alpinejs/alpine#${t}`
                )
              : 1 !== e.content.childElementCount &&
                console.warn(
                  `Alpine: <template> tag with [${t}] encountered with an unexpected number of root elements. Make sure <template> has a single root element. `
                );
          }
          function c(e) {
            return e
              .replace(/([a-z])([A-Z])/g, "$1-$2")
              .replace(/[_\s]/, "-")
              .toLowerCase();
          }
          function l(e) {
            return e.toLowerCase().replace(/-(\w)/g, (e, t) => t.toUpperCase());
          }
          function u(e, t) {
            if (!1 === t(e)) return;
            let n = e.firstElementChild;
            for (; n; ) u(n, t), (n = n.nextElementSibling);
          }
          function d(e, t) {
            var n;
            return function () {
              var r = this,
                i = arguments,
                o = function () {
                  (n = null), e.apply(r, i);
                };
              clearTimeout(n), (n = setTimeout(o, t));
            };
          }
          const h = (e, t, n) => {
            if (
              (console.warn(
                `Alpine Error: "${n}"\n\nExpression: "${t}"\nElement:`,
                e
              ),
              !o())
            )
              throw (Object.assign(n, { el: e, expression: t }), n);
          };
          function f(e, { el: t, expression: n }) {
            try {
              const r = e();
              return r instanceof Promise ? r.catch((e) => h(t, n, e)) : r;
            } catch (e) {
              h(t, n, e);
            }
          }
          function p(e, t, n, r = {}) {
            return f(
              () =>
                "function" == typeof t
                  ? t.call(n)
                  : new Function(
                      ["$data", ...Object.keys(r)],
                      `var __alpine_result; with($data) { __alpine_result = ${t} }; return __alpine_result`
                    )(n, ...Object.values(r)),
              { el: e, expression: t }
            );
          }
          function m(e, t, n, r = {}) {
            return f(
              () => {
                if ("function" == typeof t)
                  return Promise.resolve(t.call(n, r.$event));
                let e = Function;
                if (
                  ((e = Object.getPrototypeOf(
                    async function () {}
                  ).constructor),
                  Object.keys(n).includes(t))
                ) {
                  let e = new Function(
                    ["dataContext", ...Object.keys(r)],
                    `with(dataContext) { return ${t} }`
                  )(n, ...Object.values(r));
                  return "function" == typeof e
                    ? Promise.resolve(e.call(n, r.$event))
                    : Promise.resolve();
                }
                return Promise.resolve(
                  new e(
                    ["dataContext", ...Object.keys(r)],
                    `with(dataContext) { ${t} }`
                  )(n, ...Object.values(r))
                );
              },
              { el: e, expression: t }
            );
          }
          const v =
            /^x-(on|bind|data|text|html|model|if|for|show|cloak|transition|ref|spread)\b/;
          function g(e) {
            const t = x(e.name);
            return v.test(t);
          }
          function _(e, t, n) {
            let r = Array.from(e.attributes).filter(g).map(b),
              i = r.filter((e) => "spread" === e.type)[0];
            if (i) {
              let n = p(e, i.expression, t.$data);
              r = r.concat(
                Object.entries(n).map(([e, t]) => b({ name: e, value: t }))
              );
            }
            return n ? r.filter((e) => e.type === n) : y(r);
          }
          function y(e) {
            let t = ["bind", "model", "show", "catch-all"];
            return e.sort((e, n) => {
              let r = -1 === t.indexOf(e.type) ? "catch-all" : e.type,
                i = -1 === t.indexOf(n.type) ? "catch-all" : n.type;
              return t.indexOf(r) - t.indexOf(i);
            });
          }
          function b({ name: e, value: t }) {
            const n = x(e),
              r = n.match(v),
              i = n.match(/:([a-zA-Z0-9\-:]+)/),
              o = n.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
            return {
              type: r ? r[1] : null,
              value: i ? i[1] : null,
              modifiers: o.map((e) => e.replace(".", "")),
              expression: t,
            };
          }
          function w(e) {
            return [
              "disabled",
              "checked",
              "required",
              "readonly",
              "hidden",
              "open",
              "selected",
              "autofocus",
              "itemscope",
              "multiple",
              "novalidate",
              "allowfullscreen",
              "allowpaymentrequest",
              "formnovalidate",
              "autoplay",
              "controls",
              "loop",
              "muted",
              "playsinline",
              "default",
              "ismap",
              "reversed",
              "async",
              "defer",
              "nomodule",
            ].includes(e);
          }
          function x(e) {
            return e.startsWith("@")
              ? e.replace("@", "x-on:")
              : e.startsWith(":")
              ? e.replace(":", "x-bind:")
              : e;
          }
          function S(e, t = Boolean) {
            return e.split(" ").filter(t);
          }
          const O = "in",
            E = "out",
            A = "cancelled";
          function k(e, t, n, r, i = !1) {
            if (i) return t();
            if (e.__x_transition && e.__x_transition.type === O) return;
            const o = _(e, r, "transition"),
              s = _(e, r, "show")[0];
            if (s && s.modifiers.includes("transition")) {
              let r = s.modifiers;
              if (r.includes("out") && !r.includes("in")) return t();
              const i = r.includes("in") && r.includes("out");
              (r = i ? r.filter((e, t) => t < r.indexOf("out")) : r),
                j(e, r, t, n);
            } else
              o.some((e) =>
                ["enter", "enter-start", "enter-end"].includes(e.value)
              )
                ? R(e, r, o, t, n)
                : t();
          }
          function P(e, t, n, r, i = !1) {
            if (i) return t();
            if (e.__x_transition && e.__x_transition.type === E) return;
            const o = _(e, r, "transition"),
              s = _(e, r, "show")[0];
            if (s && s.modifiers.includes("transition")) {
              let r = s.modifiers;
              if (r.includes("in") && !r.includes("out")) return t();
              const i = r.includes("in") && r.includes("out");
              (r = i ? r.filter((e, t) => t > r.indexOf("out")) : r),
                I(e, r, i, t, n);
            } else
              o.some((e) =>
                ["leave", "leave-start", "leave-end"].includes(e.value)
              )
                ? D(e, r, o, t, n)
                : t();
          }
          function j(e, t, n, r) {
            $(
              e,
              t,
              n,
              () => {},
              r,
              {
                duration: C(t, "duration", 150),
                origin: C(t, "origin", "center"),
                first: { opacity: 0, scale: C(t, "scale", 95) },
                second: { opacity: 1, scale: 100 },
              },
              O
            );
          }
          function I(e, t, n, r, i) {
            $(
              e,
              t,
              () => {},
              r,
              i,
              {
                duration: n ? C(t, "duration", 150) : C(t, "duration", 150) / 2,
                origin: C(t, "origin", "center"),
                first: { opacity: 1, scale: 100 },
                second: { opacity: 0, scale: C(t, "scale", 95) },
              },
              E
            );
          }
          function C(e, t, n) {
            if (-1 === e.indexOf(t)) return n;
            const r = e[e.indexOf(t) + 1];
            if (!r) return n;
            if ("scale" === t && !q(r)) return n;
            if ("duration" === t) {
              let e = r.match(/([0-9]+)ms/);
              if (e) return e[1];
            }
            return "origin" === t &&
              ["top", "right", "left", "center", "bottom"].includes(
                e[e.indexOf(t) + 2]
              )
              ? [r, e[e.indexOf(t) + 2]].join(" ")
              : r;
          }
          function $(e, t, n, r, i, o, s) {
            e.__x_transition &&
              e.__x_transition.cancel &&
              e.__x_transition.cancel();
            const a = e.style.opacity,
              c = e.style.transform,
              l = e.style.transformOrigin,
              u = !t.includes("opacity") && !t.includes("scale"),
              d = u || t.includes("opacity"),
              h = u || t.includes("scale"),
              f = {
                start() {
                  d && (e.style.opacity = o.first.opacity),
                    h && (e.style.transform = `scale(${o.first.scale / 100})`);
                },
                during() {
                  h && (e.style.transformOrigin = o.origin),
                    (e.style.transitionProperty = [
                      d ? "opacity" : "",
                      h ? "transform" : "",
                    ]
                      .join(" ")
                      .trim()),
                    (e.style.transitionDuration = o.duration / 1e3 + "s"),
                    (e.style.transitionTimingFunction =
                      "cubic-bezier(0.4, 0.0, 0.2, 1)");
                },
                show() {
                  n();
                },
                end() {
                  d && (e.style.opacity = o.second.opacity),
                    h && (e.style.transform = `scale(${o.second.scale / 100})`);
                },
                hide() {
                  r();
                },
                cleanup() {
                  d && (e.style.opacity = a),
                    h && (e.style.transform = c),
                    h && (e.style.transformOrigin = l),
                    (e.style.transitionProperty = null),
                    (e.style.transitionDuration = null),
                    (e.style.transitionTimingFunction = null);
                },
              };
            z(e, f, s, i);
          }
          const T = (e, t, n) =>
            "function" == typeof e ? n.evaluateReturnExpression(t, e) : e;
          function R(e, t, n, r, i) {
            L(
              e,
              S(
                T(
                  (n.find((e) => "enter" === e.value) || { expression: "" })
                    .expression,
                  e,
                  t
                )
              ),
              S(
                T(
                  (
                    n.find((e) => "enter-start" === e.value) || {
                      expression: "",
                    }
                  ).expression,
                  e,
                  t
                )
              ),
              S(
                T(
                  (n.find((e) => "enter-end" === e.value) || { expression: "" })
                    .expression,
                  e,
                  t
                )
              ),
              r,
              () => {},
              O,
              i
            );
          }
          function D(e, t, n, r, i) {
            L(
              e,
              S(
                T(
                  (n.find((e) => "leave" === e.value) || { expression: "" })
                    .expression,
                  e,
                  t
                )
              ),
              S(
                T(
                  (
                    n.find((e) => "leave-start" === e.value) || {
                      expression: "",
                    }
                  ).expression,
                  e,
                  t
                )
              ),
              S(
                T(
                  (n.find((e) => "leave-end" === e.value) || { expression: "" })
                    .expression,
                  e,
                  t
                )
              ),
              () => {},
              r,
              E,
              i
            );
          }
          function L(e, t, n, r, i, o, s, a) {
            e.__x_transition &&
              e.__x_transition.cancel &&
              e.__x_transition.cancel();
            const c = e.__x_original_classes || [],
              l = {
                start() {
                  e.classList.add(...n);
                },
                during() {
                  e.classList.add(...t);
                },
                show() {
                  i();
                },
                end() {
                  e.classList.remove(...n.filter((e) => !c.includes(e))),
                    e.classList.add(...r);
                },
                hide() {
                  o();
                },
                cleanup() {
                  e.classList.remove(...t.filter((e) => !c.includes(e))),
                    e.classList.remove(...r.filter((e) => !c.includes(e)));
                },
              };
            z(e, l, s, a);
          }
          function z(e, t, n, r) {
            const i = N(() => {
              t.hide(), e.isConnected && t.cleanup(), delete e.__x_transition;
            });
            (e.__x_transition = {
              type: n,
              cancel: N(() => {
                r(A), i();
              }),
              finish: i,
              nextFrame: null,
            }),
              t.start(),
              t.during(),
              (e.__x_transition.nextFrame = requestAnimationFrame(() => {
                let n =
                  1e3 *
                  Number(
                    getComputedStyle(e)
                      .transitionDuration.replace(/,.*/, "")
                      .replace("s", "")
                  );
                0 === n &&
                  (n =
                    1e3 *
                    Number(
                      getComputedStyle(e).animationDuration.replace("s", "")
                    )),
                  t.show(),
                  (e.__x_transition.nextFrame = requestAnimationFrame(() => {
                    t.end(), setTimeout(e.__x_transition.finish, n);
                  }));
              }));
          }
          function q(e) {
            return !Array.isArray(e) && !isNaN(e);
          }
          function N(e) {
            let t = !1;
            return function () {
              t || ((t = !0), e.apply(this, arguments));
            };
          }
          function M(e, t, n, r, i) {
            a(t, "x-for");
            let o = V(
                "function" == typeof n ? e.evaluateReturnExpression(t, n) : n
              ),
              s = B(e, t, o, i),
              c = t;
            s.forEach((n, a) => {
              let l = F(o, n, a, s, i()),
                u = U(e, t, a, l),
                d = W(c.nextElementSibling, u);
              d
                ? (delete d.__x_for_key,
                  (d.__x_for = l),
                  e.updateElements(d, () => d.__x_for))
                : ((d = Q(t, c)),
                  k(
                    d,
                    () => {},
                    () => {},
                    e,
                    r
                  ),
                  (d.__x_for = l),
                  e.initializeElements(d, () => d.__x_for)),
                (c = d),
                (c.__x_for_key = u);
            }),
              J(c, e);
          }
          function V(e) {
            let t = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/,
              n = /^\(|\)$/g,
              r = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/,
              i = String(e).match(r);
            if (!i) return;
            let o = {};
            o.items = i[2].trim();
            let s = i[1].trim().replace(n, ""),
              a = s.match(t);
            return (
              a
                ? ((o.item = s.replace(t, "").trim()),
                  (o.index = a[1].trim()),
                  a[2] && (o.collection = a[2].trim()))
                : (o.item = s),
              o
            );
          }
          function F(e, t, r, i, o) {
            let s = o ? n({}, o) : {};
            return (
              (s[e.item] = t),
              e.index && (s[e.index] = r),
              e.collection && (s[e.collection] = i),
              s
            );
          }
          function U(e, t, n, r) {
            let i = _(t, e, "bind").filter((e) => "key" === e.value)[0];
            return i ? e.evaluateReturnExpression(t, i.expression, () => r) : n;
          }
          function B(e, t, n, r) {
            let i = _(t, e, "if")[0];
            if (i && !e.evaluateReturnExpression(t, i.expression)) return [];
            let o = e.evaluateReturnExpression(t, n.items, r);
            return (
              q(o) && o >= 0 && (o = Array.from(Array(o).keys(), (e) => e + 1)),
              o
            );
          }
          function Q(e, t) {
            let n = document.importNode(e.content, !0);
            return (
              t.parentElement.insertBefore(n, t.nextElementSibling),
              t.nextElementSibling
            );
          }
          function W(e, t) {
            if (!e) return;
            if (void 0 === e.__x_for_key) return;
            if (e.__x_for_key === t) return e;
            let n = e;
            for (; n; ) {
              if (n.__x_for_key === t)
                return n.parentElement.insertBefore(n, e);
              n =
                !(
                  !n.nextElementSibling ||
                  void 0 === n.nextElementSibling.__x_for_key
                ) && n.nextElementSibling;
            }
          }
          function J(e, t) {
            for (
              var n =
                !(
                  !e.nextElementSibling ||
                  void 0 === e.nextElementSibling.__x_for_key
                ) && e.nextElementSibling;
              n;

            ) {
              let e = n,
                r = n.nextElementSibling;
              P(
                n,
                () => {
                  e.remove();
                },
                () => {},
                t
              ),
                (n = !(!r || void 0 === r.__x_for_key) && r);
            }
          }
          function H(e, t, n, r, o, a, c) {
            var u = e.evaluateReturnExpression(t, r, o);
            if ("value" === n) {
              if (
                We.ignoreFocusedForValueBinding &&
                document.activeElement.isSameNode(t)
              )
                return;
              if (
                (void 0 === u && String(r).match(/\./) && (u = ""),
                "radio" === t.type)
              )
                void 0 === t.attributes.value && "bind" === a
                  ? (t.value = u)
                  : "bind" !== a && (t.checked = s(t.value, u));
              else if ("checkbox" === t.type)
                "boolean" == typeof u ||
                [null, void 0].includes(u) ||
                "bind" !== a
                  ? "bind" !== a &&
                    (Array.isArray(u)
                      ? (t.checked = u.some((e) => s(e, t.value)))
                      : (t.checked = !!u))
                  : (t.value = String(u));
              else if ("SELECT" === t.tagName) Z(t, u);
              else {
                if (t.value === u) return;
                t.value = u;
              }
            } else if ("class" === n)
              if (Array.isArray(u)) {
                const e = t.__x_original_classes || [];
                t.setAttribute("class", i(e.concat(u)).join(" "));
              } else if ("object" == typeof u)
                Object.keys(u)
                  .sort((e, t) => u[e] - u[t])
                  .forEach((e) => {
                    u[e]
                      ? S(e).forEach((e) => t.classList.add(e))
                      : S(e).forEach((e) => t.classList.remove(e));
                  });
              else {
                const e = t.__x_original_classes || [],
                  n = u ? S(u) : [];
                t.setAttribute("class", i(e.concat(n)).join(" "));
              }
            else
              (n = c.includes("camel") ? l(n) : n),
                [null, void 0, !1].includes(u)
                  ? t.removeAttribute(n)
                  : w(n)
                  ? K(t, n, n)
                  : K(t, n, u);
          }
          function K(e, t, n) {
            e.getAttribute(t) != n && e.setAttribute(t, n);
          }
          function Z(e, t) {
            const n = [].concat(t).map((e) => e + "");
            Array.from(e.options).forEach((e) => {
              e.selected = n.includes(e.value || e.text);
            });
          }
          function G(e, t, n) {
            void 0 === t && String(n).match(/\./) && (t = ""),
              (e.textContent = t);
          }
          function X(e, t, n, r) {
            t.innerHTML = e.evaluateReturnExpression(t, n, r);
          }
          function Y(e, t, n, r, i = !1) {
            const o = () => {
                (t.style.display = "none"), (t.__x_is_shown = !1);
              },
              s = () => {
                1 === t.style.length && "none" === t.style.display
                  ? t.removeAttribute("style")
                  : t.style.removeProperty("display"),
                  (t.__x_is_shown = !0);
              };
            if (!0 === i) return void (n ? s() : o());
            const a = (r, i) => {
              n
                ? (("none" === t.style.display || t.__x_transition) &&
                    k(
                      t,
                      () => {
                        s();
                      },
                      i,
                      e
                    ),
                  r(() => {}))
                : "none" !== t.style.display
                ? P(
                    t,
                    () => {
                      r(() => {
                        o();
                      });
                    },
                    i,
                    e
                  )
                : r(() => {});
            };
            r.includes("immediate")
              ? a(
                  (e) => e(),
                  () => {}
                )
              : (e.showDirectiveLastElement &&
                  !e.showDirectiveLastElement.contains(t) &&
                  e.executeAndClearRemainingShowDirectiveStack(),
                e.showDirectiveStack.push(a),
                (e.showDirectiveLastElement = t));
          }
          function ee(e, t, n, r, i) {
            a(t, "x-if");
            const o =
              t.nextElementSibling &&
              !0 === t.nextElementSibling.__x_inserted_me;
            if (!n || (o && !t.__x_transition))
              !n &&
                o &&
                P(
                  t.nextElementSibling,
                  () => {
                    t.nextElementSibling.remove();
                  },
                  () => {},
                  e,
                  r
                );
            else {
              const n = document.importNode(t.content, !0);
              t.parentElement.insertBefore(n, t.nextElementSibling),
                k(
                  t.nextElementSibling,
                  () => {},
                  () => {},
                  e,
                  r
                ),
                e.initializeElements(t.nextElementSibling, i),
                (t.nextElementSibling.__x_inserted_me = !0);
            }
          }
          function te(e, t, n, r, i, o = {}) {
            const s = { passive: r.includes("passive") };
            let a, c;
            if (
              (r.includes("camel") && (n = l(n)),
              r.includes("away")
                ? ((c = document),
                  (a = (c) => {
                    t.contains(c.target) ||
                      (t.offsetWidth < 1 && t.offsetHeight < 1) ||
                      (ne(e, i, c, o),
                      r.includes("once") &&
                        document.removeEventListener(n, a, s));
                  }))
                : ((c = r.includes("window")
                    ? window
                    : r.includes("document")
                    ? document
                    : t),
                  (a = (l) => {
                    (c !== window && c !== document) ||
                    document.body.contains(t)
                      ? (re(n) && ie(l, r)) ||
                        (r.includes("prevent") && l.preventDefault(),
                        r.includes("stop") && l.stopPropagation(),
                        r.includes("self") && l.target !== t) ||
                        ne(e, i, l, o).then((e) => {
                          !1 === e
                            ? l.preventDefault()
                            : r.includes("once") &&
                              c.removeEventListener(n, a, s);
                        })
                      : c.removeEventListener(n, a, s);
                  })),
              r.includes("debounce"))
            ) {
              let e = r[r.indexOf("debounce") + 1] || "invalid-wait",
                t = q(e.split("ms")[0]) ? Number(e.split("ms")[0]) : 250;
              a = d(a, t);
            }
            c.addEventListener(n, a, s);
          }
          function ne(e, t, r, i) {
            return e.evaluateCommandExpression(r.target, t, () =>
              n(n({}, i()), {}, { $event: r })
            );
          }
          function re(e) {
            return ["keydown", "keyup"].includes(e);
          }
          function ie(e, t) {
            let n = t.filter(
              (e) => !["window", "document", "prevent", "stop"].includes(e)
            );
            if (n.includes("debounce")) {
              let e = n.indexOf("debounce");
              n.splice(
                e,
                q((n[e + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1
              );
            }
            if (0 === n.length) return !1;
            if (1 === n.length && n[0] === oe(e.key)) return !1;
            const r = ["ctrl", "shift", "alt", "meta", "cmd", "super"].filter(
              (e) => n.includes(e)
            );
            return (
              (n = n.filter((e) => !r.includes(e))),
              !(
                r.length > 0 &&
                r.filter(
                  (t) => (
                    ("cmd" !== t && "super" !== t) || (t = "meta"), e[`${t}Key`]
                  )
                ).length === r.length &&
                n[0] === oe(e.key)
              )
            );
          }
          function oe(e) {
            switch (e) {
              case "/":
                return "slash";
              case " ":
              case "Spacebar":
                return "space";
              default:
                return e && c(e);
            }
          }
          function se(e, t, r, i, o) {
            var s =
              "select" === t.tagName.toLowerCase() ||
              ["checkbox", "radio"].includes(t.type) ||
              r.includes("lazy")
                ? "change"
                : "input";
            te(e, t, s, r, `${i} = rightSideOfExpression($event, ${i})`, () =>
              n(n({}, o()), {}, { rightSideOfExpression: ae(t, r, i) })
            );
          }
          function ae(e, t, n) {
            return (
              "radio" === e.type &&
                (e.hasAttribute("name") || e.setAttribute("name", n)),
              (n, r) => {
                if (n instanceof CustomEvent && n.detail) return n.detail;
                if ("checkbox" === e.type) {
                  if (Array.isArray(r)) {
                    const e = t.includes("number")
                      ? ce(n.target.value)
                      : n.target.value;
                    return n.target.checked
                      ? r.concat([e])
                      : r.filter((t) => !s(t, e));
                  }
                  return n.target.checked;
                }
                if ("select" === e.tagName.toLowerCase() && e.multiple)
                  return t.includes("number")
                    ? Array.from(n.target.selectedOptions).map((e) =>
                        ce(e.value || e.text)
                      )
                    : Array.from(n.target.selectedOptions).map(
                        (e) => e.value || e.text
                      );
                {
                  const e = n.target.value;
                  return t.includes("number")
                    ? ce(e)
                    : t.includes("trim")
                    ? e.trim()
                    : e;
                }
              }
            );
          }
          function ce(e) {
            const t = e ? parseFloat(e) : null;
            return q(t) ? t : e;
          }
          const { isArray: le } = Array,
            {
              getPrototypeOf: ue,
              create: de,
              defineProperty: he,
              defineProperties: fe,
              isExtensible: pe,
              getOwnPropertyDescriptor: me,
              getOwnPropertyNames: ve,
              getOwnPropertySymbols: ge,
              preventExtensions: _e,
              hasOwnProperty: ye,
            } = Object,
            { push: be, concat: we, map: xe } = Array.prototype;
          function Se(e) {
            return void 0 === e;
          }
          function Oe(e) {
            return "function" == typeof e;
          }
          function Ee(e) {
            return "object" == typeof e;
          }
          const Ae = new WeakMap();
          function ke(e, t) {
            Ae.set(e, t);
          }
          const Pe = (e) => Ae.get(e) || e;
          function je(e, t) {
            return e.valueIsObservable(t) ? e.getProxy(t) : t;
          }
          function Ie(e) {
            return ye.call(e, "value") && (e.value = Pe(e.value)), e;
          }
          function Ce(e, t, n) {
            we.call(ve(n), ge(n)).forEach((r) => {
              let i = me(n, r);
              i.configurable || (i = Ve(e, i, je)), he(t, r, i);
            }),
              _e(t);
          }
          class $e {
            constructor(e, t) {
              (this.originalTarget = t), (this.membrane = e);
            }
            get(e, t) {
              const { originalTarget: n, membrane: r } = this,
                i = n[t],
                { valueObserved: o } = r;
              return o(n, t), r.getProxy(i);
            }
            set(e, t, n) {
              const {
                originalTarget: r,
                membrane: { valueMutated: i },
              } = this;
              return (
                r[t] !== n
                  ? ((r[t] = n), i(r, t))
                  : "length" === t && le(r) && i(r, t),
                !0
              );
            }
            deleteProperty(e, t) {
              const {
                originalTarget: n,
                membrane: { valueMutated: r },
              } = this;
              return delete n[t], r(n, t), !0;
            }
            apply(e, t, n) {}
            construct(e, t, n) {}
            has(e, t) {
              const {
                originalTarget: n,
                membrane: { valueObserved: r },
              } = this;
              return r(n, t), t in n;
            }
            ownKeys(e) {
              const { originalTarget: t } = this;
              return we.call(ve(t), ge(t));
            }
            isExtensible(e) {
              const t = pe(e);
              if (!t) return t;
              const { originalTarget: n, membrane: r } = this,
                i = pe(n);
              return i || Ce(r, e, n), i;
            }
            setPrototypeOf(e, t) {}
            getPrototypeOf(e) {
              const { originalTarget: t } = this;
              return ue(t);
            }
            getOwnPropertyDescriptor(e, t) {
              const { originalTarget: n, membrane: r } = this,
                { valueObserved: i } = this.membrane;
              i(n, t);
              let o = me(n, t);
              if (Se(o)) return o;
              const s = me(e, t);
              return Se(s)
                ? ((o = Ve(r, o, je)), o.configurable || he(e, t, o), o)
                : s;
            }
            preventExtensions(e) {
              const { originalTarget: t, membrane: n } = this;
              return Ce(n, e, t), _e(t), !0;
            }
            defineProperty(e, t, n) {
              const { originalTarget: r, membrane: i } = this,
                { valueMutated: o } = i,
                { configurable: s } = n;
              if (ye.call(n, "writable") && !ye.call(n, "value")) {
                const e = me(r, t);
                n.value = e.value;
              }
              return (
                he(r, t, Ie(n)), !1 === s && he(e, t, Ve(i, n, je)), o(r, t), !0
              );
            }
          }
          function Te(e, t) {
            return e.valueIsObservable(t) ? e.getReadOnlyProxy(t) : t;
          }
          class Re {
            constructor(e, t) {
              (this.originalTarget = t), (this.membrane = e);
            }
            get(e, t) {
              const { membrane: n, originalTarget: r } = this,
                i = r[t],
                { valueObserved: o } = n;
              return o(r, t), n.getReadOnlyProxy(i);
            }
            set(e, t, n) {
              return !1;
            }
            deleteProperty(e, t) {
              return !1;
            }
            apply(e, t, n) {}
            construct(e, t, n) {}
            has(e, t) {
              const {
                originalTarget: n,
                membrane: { valueObserved: r },
              } = this;
              return r(n, t), t in n;
            }
            ownKeys(e) {
              const { originalTarget: t } = this;
              return we.call(ve(t), ge(t));
            }
            setPrototypeOf(e, t) {}
            getOwnPropertyDescriptor(e, t) {
              const { originalTarget: n, membrane: r } = this,
                { valueObserved: i } = r;
              i(n, t);
              let o = me(n, t);
              if (Se(o)) return o;
              const s = me(e, t);
              return Se(s)
                ? ((o = Ve(r, o, Te)),
                  ye.call(o, "set") && (o.set = void 0),
                  o.configurable || he(e, t, o),
                  o)
                : s;
            }
            preventExtensions(e) {
              return !1;
            }
            defineProperty(e, t, n) {
              return !1;
            }
          }
          function De(e) {
            let t;
            return le(e) ? (t = []) : Ee(e) && (t = {}), t;
          }
          const Le = Object.prototype;
          function ze(e) {
            if (null === e) return !1;
            if ("object" != typeof e) return !1;
            if (le(e)) return !0;
            const t = ue(e);
            return t === Le || null === t || null === ue(t);
          }
          const qe = (e, t) => {},
            Ne = (e, t) => {},
            Me = (e) => e;
          function Ve(e, t, n) {
            const { set: r, get: i } = t;
            return (
              ye.call(t, "value")
                ? (t.value = n(e, t.value))
                : (Se(i) ||
                    (t.get = function () {
                      return n(e, i.call(Pe(this)));
                    }),
                  Se(r) ||
                    (t.set = function (t) {
                      r.call(Pe(this), e.unwrapProxy(t));
                    })),
              t
            );
          }
          class Fe {
            constructor(e) {
              if (
                ((this.valueDistortion = Me),
                (this.valueMutated = Ne),
                (this.valueObserved = qe),
                (this.valueIsObservable = ze),
                (this.objectGraph = new WeakMap()),
                !Se(e))
              ) {
                const {
                  valueDistortion: t,
                  valueMutated: n,
                  valueObserved: r,
                  valueIsObservable: i,
                } = e;
                (this.valueDistortion = Oe(t) ? t : Me),
                  (this.valueMutated = Oe(n) ? n : Ne),
                  (this.valueObserved = Oe(r) ? r : qe),
                  (this.valueIsObservable = Oe(i) ? i : ze);
              }
            }
            getProxy(e) {
              const t = Pe(e),
                n = this.valueDistortion(t);
              if (this.valueIsObservable(n)) {
                const r = this.getReactiveState(t, n);
                return r.readOnly === e ? e : r.reactive;
              }
              return n;
            }
            getReadOnlyProxy(e) {
              e = Pe(e);
              const t = this.valueDistortion(e);
              return this.valueIsObservable(t)
                ? this.getReactiveState(e, t).readOnly
                : t;
            }
            unwrapProxy(e) {
              return Pe(e);
            }
            getReactiveState(e, t) {
              const { objectGraph: n } = this;
              let r = n.get(t);
              if (r) return r;
              const i = this;
              return (
                (r = {
                  get reactive() {
                    const n = new $e(i, t),
                      r = new Proxy(De(t), n);
                    return ke(r, e), he(this, "reactive", { value: r }), r;
                  },
                  get readOnly() {
                    const n = new Re(i, t),
                      r = new Proxy(De(t), n);
                    return ke(r, e), he(this, "readOnly", { value: r }), r;
                  },
                }),
                n.set(t, r),
                r
              );
            }
          }
          function Ue(e, t) {
            let n = new Fe({
              valueMutated(e, n) {
                t(e, n);
              },
            });
            return { data: n.getProxy(e), membrane: n };
          }
          function Be(e, t) {
            let n = e.unwrapProxy(t),
              r = {};
            return (
              Object.keys(n).forEach((e) => {
                ["$el", "$refs", "$nextTick", "$watch"].includes(e) ||
                  (r[e] = n[e]);
              }),
              r
            );
          }
          class Qe {
            constructor(e, t = null) {
              this.$el = e;
              const n = this.$el.getAttribute("x-data"),
                r = "" === n ? "{}" : n,
                i = this.$el.getAttribute("x-init");
              let o = { $el: this.$el },
                s = t ? t.$el : this.$el;
              Object.entries(We.magicProperties).forEach(([e, t]) => {
                Object.defineProperty(o, `$${e}`, {
                  get: function () {
                    return t(s);
                  },
                });
              }),
                (this.unobservedData = t ? t.getUnobservedData() : p(e, r, o));
              let { membrane: a, data: c } = this.wrapDataInObservable(
                this.unobservedData
              );
              var l;
              (this.$data = c),
                (this.membrane = a),
                (this.unobservedData.$el = this.$el),
                (this.unobservedData.$refs = this.getRefsProxy()),
                (this.nextTickStack = []),
                (this.unobservedData.$nextTick = (e) => {
                  this.nextTickStack.push(e);
                }),
                (this.watchers = {}),
                (this.unobservedData.$watch = (e, t) => {
                  this.watchers[e] || (this.watchers[e] = []),
                    this.watchers[e].push(t);
                }),
                Object.entries(We.magicProperties).forEach(([e, t]) => {
                  Object.defineProperty(this.unobservedData, `$${e}`, {
                    get: function () {
                      return t(s, this.$el);
                    },
                  });
                }),
                (this.showDirectiveStack = []),
                this.showDirectiveLastElement,
                t || We.onBeforeComponentInitializeds.forEach((e) => e(this)),
                i &&
                  !t &&
                  ((this.pauseReactivity = !0),
                  (l = this.evaluateReturnExpression(this.$el, i)),
                  (this.pauseReactivity = !1)),
                this.initializeElements(this.$el, () => {}, t),
                this.listenForNewElementsToInitialize(),
                "function" == typeof l && l.call(this.$data),
                t ||
                  setTimeout(() => {
                    We.onComponentInitializeds.forEach((e) => e(this));
                  }, 0);
            }
            getUnobservedData() {
              return Be(this.membrane, this.$data);
            }
            wrapDataInObservable(e) {
              var t = this;
              let n = d(function () {
                t.updateElements(t.$el);
              }, 0);
              return Ue(e, (e, r) => {
                t.watchers[r]
                  ? t.watchers[r].forEach((t) => t(e[r]))
                  : Array.isArray(e)
                  ? Object.keys(t.watchers).forEach((n) => {
                      let i = n.split(".");
                      "length" !== r &&
                        i.reduce(
                          (r, i) => (
                            Object.is(e, r[i]) &&
                              t.watchers[n].forEach((t) => t(e)),
                            r[i]
                          ),
                          t.unobservedData
                        );
                    })
                  : Object.keys(t.watchers)
                      .filter((e) => e.includes("."))
                      .forEach((n) => {
                        let i = n.split(".");
                        r === i[i.length - 1] &&
                          i.reduce(
                            (i, o) => (
                              Object.is(e, i) &&
                                t.watchers[n].forEach((t) => t(e[r])),
                              i[o]
                            ),
                            t.unobservedData
                          );
                      }),
                  t.pauseReactivity || n();
              });
            }
            walkAndSkipNestedComponents(e, t, n = () => {}) {
              u(e, (e) =>
                e.hasAttribute("x-data") && !e.isSameNode(this.$el)
                  ? (e.__x || n(e), !1)
                  : t(e)
              );
            }
            initializeElements(e, t = () => {}, n = !1) {
              this.walkAndSkipNestedComponents(
                e,
                (e) =>
                  void 0 === e.__x_for_key &&
                  void 0 === e.__x_inserted_me &&
                  void this.initializeElement(e, t, !n),
                (e) => {
                  n || (e.__x = new Qe(e));
                }
              ),
                this.executeAndClearRemainingShowDirectiveStack(),
                this.executeAndClearNextTickStack(e);
            }
            initializeElement(e, t, n = !0) {
              e.hasAttribute("class") &&
                _(e, this).length > 0 &&
                (e.__x_original_classes = S(e.getAttribute("class"))),
                n && this.registerListeners(e, t),
                this.resolveBoundAttributes(e, !0, t);
            }
            updateElements(e, t = () => {}) {
              this.walkAndSkipNestedComponents(
                e,
                (e) => {
                  if (void 0 !== e.__x_for_key && !e.isSameNode(this.$el))
                    return !1;
                  this.updateElement(e, t);
                },
                (e) => {
                  e.__x = new Qe(e);
                }
              ),
                this.executeAndClearRemainingShowDirectiveStack(),
                this.executeAndClearNextTickStack(e);
            }
            executeAndClearNextTickStack(e) {
              e === this.$el &&
                this.nextTickStack.length > 0 &&
                requestAnimationFrame(() => {
                  for (; this.nextTickStack.length > 0; )
                    this.nextTickStack.shift()();
                });
            }
            executeAndClearRemainingShowDirectiveStack() {
              this.showDirectiveStack
                .reverse()
                .map(
                  (e) =>
                    new Promise((t, n) => {
                      e(t, n);
                    })
                )
                .reduce(
                  (e, t) =>
                    e.then(() =>
                      t.then((e) => {
                        e();
                      })
                    ),
                  Promise.resolve(() => {})
                )
                .catch((e) => {
                  if (e !== A) throw e;
                }),
                (this.showDirectiveStack = []),
                (this.showDirectiveLastElement = void 0);
            }
            updateElement(e, t) {
              this.resolveBoundAttributes(e, !1, t);
            }
            registerListeners(e, t) {
              _(e, this).forEach(
                ({ type: n, value: r, modifiers: i, expression: o }) => {
                  switch (n) {
                    case "on":
                      te(this, e, r, i, o, t);
                      break;
                    case "model":
                      se(this, e, i, o, t);
                  }
                }
              );
            }
            resolveBoundAttributes(e, t = !1, n) {
              let r = _(e, this);
              r.forEach(
                ({ type: i, value: o, modifiers: s, expression: a }) => {
                  switch (i) {
                    case "model":
                      H(this, e, "value", a, n, i, s);
                      break;
                    case "bind":
                      if ("template" === e.tagName.toLowerCase() && "key" === o)
                        return;
                      H(this, e, o, a, n, i, s);
                      break;
                    case "text":
                      var c = this.evaluateReturnExpression(e, a, n);
                      G(e, c, a);
                      break;
                    case "html":
                      X(this, e, a, n);
                      break;
                    case "show":
                      (c = this.evaluateReturnExpression(e, a, n)),
                        Y(this, e, c, s, t);
                      break;
                    case "if":
                      if (r.some((e) => "for" === e.type)) return;
                      (c = this.evaluateReturnExpression(e, a, n)),
                        ee(this, e, c, t, n);
                      break;
                    case "for":
                      M(this, e, a, t, n);
                      break;
                    case "cloak":
                      e.removeAttribute("x-cloak");
                  }
                }
              );
            }
            evaluateReturnExpression(e, t, r = () => {}) {
              return p(
                e,
                t,
                this.$data,
                n(n({}, r()), {}, { $dispatch: this.getDispatchFunction(e) })
              );
            }
            evaluateCommandExpression(e, t, r = () => {}) {
              return m(
                e,
                t,
                this.$data,
                n(n({}, r()), {}, { $dispatch: this.getDispatchFunction(e) })
              );
            }
            getDispatchFunction(e) {
              return (t, n = {}) => {
                e.dispatchEvent(new CustomEvent(t, { detail: n, bubbles: !0 }));
              };
            }
            listenForNewElementsToInitialize() {
              const e = this.$el,
                t = { childList: !0, attributes: !0, subtree: !0 };
              new MutationObserver((e) => {
                for (let t = 0; t < e.length; t++) {
                  const n = e[t].target.closest("[x-data]");
                  if (n && n.isSameNode(this.$el)) {
                    if (
                      "attributes" === e[t].type &&
                      "x-data" === e[t].attributeName
                    ) {
                      const n = e[t].target.getAttribute("x-data") || "{}",
                        r = p(this.$el, n, { $el: this.$el });
                      Object.keys(r).forEach((e) => {
                        this.$data[e] !== r[e] && (this.$data[e] = r[e]);
                      });
                    }
                    e[t].addedNodes.length > 0 &&
                      e[t].addedNodes.forEach((e) => {
                        1 !== e.nodeType ||
                          e.__x_inserted_me ||
                          (!e.matches("[x-data]") || e.__x
                            ? this.initializeElements(e)
                            : (e.__x = new Qe(e)));
                      });
                  }
                }
              }).observe(e, t);
            }
            getRefsProxy() {
              var e = this;
              return new Proxy(
                {},
                {
                  get(t, n) {
                    return (
                      "$isAlpineProxy" === n ||
                      (e.walkAndSkipNestedComponents(e.$el, (e) => {
                        e.hasAttribute("x-ref") &&
                          e.getAttribute("x-ref") === n &&
                          (r = e);
                      }),
                      r)
                    );
                    var r;
                  },
                }
              );
            }
          }
          const We = {
            version: "2.8.2",
            pauseMutationObserver: !1,
            magicProperties: {},
            onComponentInitializeds: [],
            onBeforeComponentInitializeds: [],
            ignoreFocusedForValueBinding: !1,
            start: async function () {
              o() || (await r()),
                this.discoverComponents((e) => {
                  this.initializeComponent(e);
                }),
                document.addEventListener("turbolinks:load", () => {
                  this.discoverUninitializedComponents((e) => {
                    this.initializeComponent(e);
                  });
                }),
                this.listenForNewUninitializedComponentsAtRunTime();
            },
            discoverComponents: function (e) {
              document.querySelectorAll("[x-data]").forEach((t) => {
                e(t);
              });
            },
            discoverUninitializedComponents: function (e, t = null) {
              const n = (t || document).querySelectorAll("[x-data]");
              Array.from(n)
                .filter((e) => void 0 === e.__x)
                .forEach((t) => {
                  e(t);
                });
            },
            listenForNewUninitializedComponentsAtRunTime: function () {
              const e = document.querySelector("body"),
                t = { childList: !0, attributes: !0, subtree: !0 };
              new MutationObserver((e) => {
                if (!this.pauseMutationObserver)
                  for (let t = 0; t < e.length; t++)
                    e[t].addedNodes.length > 0 &&
                      e[t].addedNodes.forEach((e) => {
                        1 === e.nodeType &&
                          ((e.parentElement &&
                            e.parentElement.closest("[x-data]")) ||
                            this.discoverUninitializedComponents((e) => {
                              this.initializeComponent(e);
                            }, e.parentElement));
                      });
              }).observe(e, t);
            },
            initializeComponent: function (e) {
              if (!e.__x)
                try {
                  e.__x = new Qe(e);
                } catch (e) {
                  setTimeout(() => {
                    throw e;
                  }, 0);
                }
            },
            clone: function (e, t) {
              t.__x || (t.__x = new Qe(t, e));
            },
            addMagicProperty: function (e, t) {
              this.magicProperties[e] = t;
            },
            onComponentInitialized: function (e) {
              this.onComponentInitializeds.push(e);
            },
            onBeforeComponentInitialized: function (e) {
              this.onBeforeComponentInitializeds.push(e);
            },
          };
          return (
            o() ||
              ((window.Alpine = We),
              window.deferLoadingAlpine
                ? window.deferLoadingAlpine(function () {
                    window.Alpine.start();
                  })
                : window.Alpine.start()),
            We
          );
        })();
      },
      17: function (e, t, n) {
        "use strict";
        function r(e, t) {
          var n =
            ("undefined" != typeof Symbol && e[Symbol.iterator]) ||
            e["@@iterator"];
          if (!n) {
            if (
              Array.isArray(e) ||
              (n = (function (e, t) {
                if (!e) return;
                if ("string" == typeof e) return i(e, t);
                var n = Object.prototype.toString.call(e).slice(8, -1);
                "Object" === n && e.constructor && (n = e.constructor.name);
                if ("Map" === n || "Set" === n) return Array.from(e);
                if (
                  "Arguments" === n ||
                  /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
                )
                  return i(e, t);
              })(e)) ||
              (t && e && "number" == typeof e.length)
            ) {
              n && (e = n);
              var r = 0,
                o = function () {};
              return {
                s: o,
                n: function () {
                  return r >= e.length
                    ? { done: !0 }
                    : { done: !1, value: e[r++] };
                },
                e: function (e) {
                  throw e;
                },
                f: o,
              };
            }
            throw new TypeError(
              "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
            );
          }
          var s,
            a = !0,
            c = !1;
          return {
            s: function () {
              n = n.call(e);
            },
            n: function () {
              var e = n.next();
              return (a = e.done), e;
            },
            e: function (e) {
              (c = !0), (s = e);
            },
            f: function () {
              try {
                a || null == n.return || n.return();
              } finally {
                if (c) throw s;
              }
            },
          };
        }
        function i(e, t) {
          (null == t || t > e.length) && (t = e.length);
          for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
          return r;
        }
        function o() {
          return {
            setAllAccordionHeights: function () {
              var e,
                t = r(this.$el.querySelectorAll("[data-content]"));
              try {
                for (t.s(); !(e = t.n()).done; ) {
                  var n = e.value;
                  n.style.maxHeight = "".concat(n.scrollHeight, "px");
                }
              } catch (e) {
                t.e(e);
              } finally {
                t.f();
              }
            },
            accordionTitle__clicked: function (e) {
              this.setAllAccordionHeights();
              var t = document.getElementById(e.currentTarget.htmlFor);
              t.checked &&
                ((t.checked = !1), e.preventDefault(), e.stopPropagation());
            },
          };
        }
        n.r(t),
          n.d(t, {
            default: function () {
              return o;
            },
          });
      },
      223: function (e, t, n) {
        "use strict";
        function r(e) {
          return {
            country: e.country,
            state: e.state,
            countryElementId: e.countryElementId,
            stateElementId: e.stateElementId,
            provinces: [],
            init: function () {
              this.initCountry(), this.initProvince();
            },
            initCountry: function () {
              this.countryElement.value = this.country;
            },
            initProvince: function () {
              var e = this;
              (this.provinces = JSON.parse(
                this.selectedElement(this.countryElement).dataset.provinces
              )),
                console.log(
                  "state",
                  this.state,
                  document.getElementById(this.stateElementId)
                ),
                this.$nextTick(function () {
                  document.getElementById(e.stateElementId).value = e.state;
                });
            },
            get countryElement() {
              return document.getElementById(this.countryElementId);
            },
            setProvince__countryChanged: function (e) {
              this.provinces = JSON.parse(
                this.selectedElement(e.target).dataset.provinces
              );
            },
            selectedElement: function (e) {
              return e.selectedOptions[0];
            },
          };
        }
        n.r(t),
          n.d(t, {
            default: function () {
              return r;
            },
          });
      },
      839: function (e, t, n) {
        "use strict";
        n.r(t),
          n.d(t, {
            default: function () {
              return i;
            },
          });
        var r = null;
        function i() {
          return {
            options: { root: null, threshold: 0.3 },
            observer: null,
            init: function (e) {
              null == r &&
                (console.log("init animated reveal"),
                (r = new IntersectionObserver(
                  this.intersectObserver__itemVisibilityChanged.bind(this),
                  this.options
                ))),
                this.$el.classList.add("ns-animated-reveal"),
                this.$el.classList.add("ns-animated-reveal--" + e),
                r.observe(this.$el);
            },
            intersectObserver__itemVisibilityChanged: function (e, t) {
              e.forEach(function (e) {
                e.isIntersecting &&
                  (e.target.classList.add("ns-animated-reveal--intersected"),
                  t.unobserve(e.target));
              });
            },
          };
        }
      },
      934: function (e, t, n) {
        "use strict";
        function r() {
          return {
            get cart() {
              return this.$store.cartStore.cart || { items: [], item_count: 0 };
            },
            isBundleChild: function (e) {
              return !!(
                e &&
                e.properties &&
                e.properties._bundle_id &&
                e.properties._bundle_role &&
                "parent" !== e.properties._bundle_role
              );
            },
            get count() {
              return (this.cart.items || []).reduce(
                function (t, e) {
                  return this.isBundleChild(e) ? t : t + Number(e.quantity || 0);
                }.bind(this),
                0
              );
            },
            get cart_has_items() {
              return this.count > 0;
            },
            showCartDrawer: function () {
              return (this.$store.cartStore.show_cart_tray = !0);
            },
          };
        }
        n.r(t),
          n.d(t, {
            default: function () {
              return r;
            },
          });
      },
      499: function (e, t, n) {
        "use strict";
        n.r(t),
          n.d(t, {
            default: function () {
              return i;
            },
          });
        var r = n(785);
        function i() {
          return {
            visibleIndexArray: [],
            current_index: 0,
            observer: null,
            load_offset: 1,
            init: function () {
              this.observer = new IntersectionObserver(
                this.intersectObserver__itemVisibilityChanged.bind(this),
                {
                  root: this.$refs.scroll_container,
                  rootMargin: "0px -50% 0px 0px",
                  threshold: 0.3,
                }
              );
              for (
                var e = 0, t = Array.from(this.$refs.scroll_container.children);
                e < t.length;
                e++
              ) {
                var n = t[e];
                this.observer.observe(n);
              }
            },
            get cart() {
              return this.$store.cartStore.cart;
            },
            get is_initialized() {
              return (
                this.cart &&
                null !== this.cart.item_count &&
                void 0 !== this.cart.item_count
              );
            },
            get item_count() {
              return this.is_initialized ? this.cart.item_count : 0;
            },
            get item_count_text() {
              return (
                this.item_count + " Item" + (this.item_count > 1 ? "s" : "")
              );
            },
            get items() {
              return this.cart.items;
            },
            get has_no_items() {
              return this.item_count < 1;
            },
            get total_price() {
              return Utils.money(this.cart.total_price, 0);
            },
            get background_image() {
              return this.item_count > 0
                ? Utils.resizeImage(this.cart.items[0].image, 1e3)
                : "";
            },
            adjustQty: function (e, t) {
              var n = {};
              (n[e.variant_id] = e.quantity + t),
                this.$store.cartStore.updateCart(n);
            },
            intersectObserver__itemVisibilityChanged: function (e) {
              var t = this;
              e.forEach(function (e) {
                var n = e.target.parentNode.children;
                (t.current_index = Array.from(n).indexOf(e.target)),
                  (t.$el.dataset.activeIndex = t.current_index),
                  e.isIntersecting
                    ? t.visibleIndexArray.includes(t.current_index) ||
                      t.visibleIndexArray.push(t.current_index)
                    : t.visibleIndexArray.includes(t.current_index) &&
                      t.visibleIndexArray.splice(
                        t.visibleIndexArray.indexOf(t.current_index),
                        1
                      );
              });
            },
            showNextItem__clicked: function (e) {
              e.preventDefault();
              var t = Math.min.apply(Math, (0, r.Z)(this.visibleIndexArray));
              this.scrollToChild(t + 1);
            },
            showPreviousItem__clicked: function (e) {
              e.preventDefault();
              var t = Math.min.apply(Math, (0, r.Z)(this.visibleIndexArray));
              this.scrollToChild(t - 1);
            },
            scrollToChild: function (e) {
              var t = this.$refs.scroll_container,
                n = t.getBoundingClientRect();
              if ((console.log("index", e), e >= 0 && e < t.children.length)) {
                var r = t.children.item(e).getBoundingClientRect();
                t.scroll({
                  left: r.left - n.left + t.scrollLeft,
                  behavior: "smooth",
                });
              }
            },
          };
        }
      },
      37: function (e, t, n) {
        "use strict";
        function r() {
          return {
            free_shipping_min_spend: 100 * window.STORE.free_shipping_limit,
            get show_cart_tray() {
              return this.$store.cartStore.show_cart_tray;
            },
            get cart() {
              return this.$store.cartStore.cart;
            },
            get is_initialized() {
              return (
                this.cart &&
                null !== this.cart.item_count &&
                void 0 !== this.cart.item_count
              );
            },
            get item_count_text() {
              return (
                this.item_count + " Item" + (1 == this.item_count ? "" : "s")
              );
            },
            get item_count() {
              return this.is_initialized ? this.cart.item_count : 0;
            },
            get items() {
              return this.cart.items;
            },
            get has_no_items() {
              return this.item_count < 1;
            },
            get show_loading_item() {
              return this.$store.cartStore.show_loading_item;
            },
            close: function () {
              this.$store.cartStore.show_cart_tray = !1;
            },
            adjustQty: function (e, t) {
              var n = {};
              (n[e.variant_id] = e.quantity + t),
                n[e.variant_id] <= 0 &&
                  e.properties.remove_valuation &&
                  e.properties.remove_valuation.toString() !=
                    e.variant_id.toString() &&
                  (n[e.properties.remove_valuation] = 0),
                this.$store.cartStore.updateCart(n);
            },
            removeItem: function (e) {
              var t = {};
              (t[e.variant_id] = 0),
                e.properties.remove_valuation &&
                  e.properties.remove_valuation.toString() !=
                    e.variant_id.toString() &&
                  (t[e.properties.remove_valuation] = 0),
                this.$store.cartStore.updateCart(t);
            },
            form__submitted: function (e) {
              (window.location = "/checkout"),
                this.$store.cartStore.showProgress();
            },
            isBundleChild(item) {
              return !!(
                item &&
                item.properties &&
                item.properties._bundle_id &&
                item.properties._bundle_role &&
                item.properties._bundle_role !== 'parent'
              );
            },

            isBundleParent(item) {
              return !!(
                item &&
                item.properties &&
                item.properties._bundle_id &&
                item.properties._bundle_role === 'parent'
              );
            },

            visibleItems() {
              return (this.items || []).filter((item) => !this.isBundleChild(item));
            },

            visibleItemCount() {
              return this.visibleItems().reduce((sum, item) => {
                return sum + Number(item.quantity || 0);
              }, 0);
            },

            visibleItemCountText() {
              const count = this.visibleItemCount();
              return count === 1 ? '1 Item' : `${count} Items`;
            },

            bundleItems(item) {
              const bundleId = item && item.properties ? item.properties._bundle_id : '';
              if (!bundleId) return [item];

              return (this.items || [])
                .filter((line) => {
                  return line.properties && line.properties._bundle_id === bundleId;
                })
                .sort((a, b) => {
                  const aRole = a.properties ? a.properties._bundle_role : '';
                  const bRole = b.properties ? b.properties._bundle_role : '';

                  const roleWeight = function(role) {
                    if (role === 'parent') return 0;
                    if (role === 'engraving') return 1;
                    if (role === 'valuation') return 2;
                    if (role === 'charm') return 3;
                    return 4;
                  };

                  if (roleWeight(aRole) !== roleWeight(bRole)) {
                    return roleWeight(aRole) - roleWeight(bRole);
                  }

                  const aSlot = parseInt(a.properties && a.properties._slot, 10);
                  const bSlot = parseInt(b.properties && b.properties._slot, 10);

                  const safeASlot = isNaN(aSlot) ? 999 : aSlot;
                  const safeBSlot = isNaN(bSlot) ? 999 : bSlot;

                  return safeASlot - safeBSlot;
                });
            },
            bundleCharmItems(item) {
              return this.bundleItems(item).filter((line) => {
                return line.properties && line.properties._bundle_role === 'charm';
              });
            },
            displayVariantTitle(item) {
              if (!item.variant_title || item.variant_title === 'Default Title') return '';
              return item.variant_title;
            },

            visibleProperties(item) {
              const properties = item.properties || {};

              return Object.entries(properties)
                .filter(([key, value]) => {
                  return (
                    key &&
                    !key.startsWith('_') &&
                    key !== '_ZapietId' &&
                    key !== 'remove_valuation' &&
                    value !== '' &&
                    value !== null
                  );
                })
                .map(([key, value]) => ({ key, value }));
            },

            displayLinePrice(item) {
              return this.bundleItems(item).reduce((sum, line) => {
                return sum + Number(line.final_line_price || 0);
              }, 0);
            },

            displayCompareLinePrice(item) {
              return this.bundleItems(item).reduce((sum, line) => {
                const compareAt = window.variantCompareAt && window.variantCompareAt[line.id];

                if (compareAt && compareAt > line.final_price) {
                  return sum + (Number(compareAt) * Number(line.quantity || 0));
                }

                return sum + Number(line.final_line_price || 0);
              }, 0);
            },

            async updateBundleAwareCart(updates) {
              const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'Accept': 'application/json'
                },
                body: JSON.stringify({ updates: updates })
              });

              if (!response.ok) {
                throw new Error(await response.text());
              }

              const cart = await response.json();

              this.$store.cartStore.cart = cart;
            },

            async removeItem(item) {
              try {
                const updates = {};

                this.bundleItems(item).forEach((line) => {
                  updates[line.key] = 0;
                });

                await this.updateBundleAwareCart(updates);
              } catch (error) {
                console.error('Remove item failed:', error);
              }
            },

            async adjustQty(item, delta) {
              try {
                const nextQty = Math.max(0, Number(item.quantity || 0) + Number(delta || 0));
                const updates = {};

                this.bundleItems(item).forEach((line) => {
                  updates[line.key] = nextQty;
                });

                await this.updateBundleAwareCart(updates);
              } catch (error) {
                console.error('Adjust quantity failed:', error);
              }
            },
          };
        }
        n.r(t),
          n.d(t, {
            default: function () {
              return r;
            },
          });
      },
      506: function (e, t, n) {
        "use strict";
        function r(e) {
          return {
            init: function () {},
            addToCart__clicked: function (e) {
              var t =
                arguments.length > 1 && void 0 !== arguments[1]
                  ? arguments[1]
                  : {};
              this.$store.cartStore.addToCart(e, t);
            },
          };
        }
        n.r(t),
          n.d(t, {
            default: function () {
              return r;
            },
          });
      },
      25: function (e, t, n) {
        "use strict";
        function r() {
          return {
            closeMenu: function (e) {
              e.target === e.currentTarget &&
                (e.preventDefault(),
                (document.getElementById("menu-toggle-checkbox").checked = !1));
            },
          };
        }
        n.r(t),
          n.d(t, {
            default: function () {
              return r;
            },
          });
      },
      715: function (e, t, n) {
        "use strict";
        n.r(t),
          n.d(t, {
            default: function () {
              return a;
            },
          });
        var r = n(592),
          i = n.n(r);
        function o(e, t) {
          var n =
            ("undefined" != typeof Symbol && e[Symbol.iterator]) ||
            e["@@iterator"];
          if (!n) {
            if (
              Array.isArray(e) ||
              (n = (function (e, t) {
                if (!e) return;
                if ("string" == typeof e) return s(e, t);
                var n = Object.prototype.toString.call(e).slice(8, -1);
                "Object" === n && e.constructor && (n = e.constructor.name);
                if ("Map" === n || "Set" === n) return Array.from(e);
                if (
                  "Arguments" === n ||
                  /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
                )
                  return s(e, t);
              })(e)) ||
              (t && e && "number" == typeof e.length)
            ) {
              n && (e = n);
              var r = 0,
                i = function () {};
              return {
                s: i,
                n: function () {
                  return r >= e.length
                    ? { done: !0 }
                    : { done: !1, value: e[r++] };
                },
                e: function (e) {
                  throw e;
                },
                f: i,
              };
            }
            throw new TypeError(
              "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
            );
          }
          var o,
            a = !0,
            c = !1;
          return {
            s: function () {
              n = n.call(e);
            },
            n: function () {
              var e = n.next();
              return (a = e.done), e;
            },
            e: function (e) {
              (c = !0), (o = e);
            },
            f: function () {
              try {
                a || null == n.return || n.return();
              } finally {
                if (c) throw o;
              }
            },
          };
        }
        function s(e, t) {
          (null == t || t > e.length) && (t = e.length);
          for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
          return r;
        }
        function a() {
          return {
            init: function () {
              var e = this;
              this.setExtraOptionDefaultValues();
              this.initCharmBuilder();

              i().watch("cartStore", function (t, n) {
                ("selected_variant" == n || n.includes("extra_option")) &&
                  e.uncheckElements();

                if ("selected_variant" == n && e.charmBuilderEnabled) {
                  e.syncCharmRows();
                }
              });
            },
            charmBuilderEnabled: false,
            charmProductsData: [],
            charmQty: 1,
            charmSelections: [],
            bundleError: "",
            charmName: "Charm",
            materialOptionPosition: 1,
            get selected_variant() {
              return this.$store.cartStore.selected_variant;
            },
            set selected_variant(e) {
              this.$store.cartStore.selected_variant = e;
            },
            get variant_id() {
              return this.selected_variant.id;
            },
            get option1() {
              return this.selected_variant.option1;
            },
            set option1(e) {
              this.setSelectedVariantFromOptions(e, this.option2, this.option3);
            },
            get option2() {
              return this.selected_variant.option2;
            },
            set option2(e) {
              this.setSelectedVariantFromOptions(this.option1, e, this.option3);
            },
            get option3() {
              return this.selected_variant.option3;
            },
            set option3(e) {
              this.setSelectedVariantFromOptions(this.option1, this.option2, e);
            },
            get price() {
              var cents = this.selected_variant.price;

              if (
                null != window.STORE.valuation_variant &&
                "true" == this.$store.cartStore.add_valuation
              ) {
                cents += window.STORE.valuation_variant.price;
              }

              if (this.charmBuilderEnabled) {
                cents += this.selectedCharmTotalCents();
              }

              return Utils.moneyWithoutCurrency(cents, 0);
            },
            get compare_price() {
              return null == window.STORE.valuation_variant ||
                "true" != this.$store.cartStore.add_valuation
                ? Utils.moneyWithoutCurrency(
                    this.selected_variant.compare_at_price,
                    0
                  )
                : Utils.moneyWithoutCurrency(
                    this.selected_variant.compare_at_price +
                      window.STORE.valuation_variant.price,
                    0
                  );
            },
            get selected_variant_available() {
              return this.selected_variant.available;
            },
            scrollToMainForm__clicked: function (e) {
              document
                .getElementById("product-form-container")
                .scrollIntoView({ behavior: "smooth", block: "center" });
            },
            productForm__submitted: function (e) {
              if (!this.charmBuilderEnabled) {
                console.log("form submitted", e.currentTarget);
                var t = new FormData(e.currentTarget);

                if (
                  null != window.STORE.valuation_variant &&
                  "true" == this.$store.cartStore.add_valuation
                ) {
                  t.append("id[]", window.STORE.valuation_variant.id);
                  t.append("id[]", t.get("id"));
                  t.append(
                    "properties[remove_valuation]",
                    window.STORE.valuation_variant.id
                  );
                  t.delete("id");
                }

                var n,
                  r = o(t.entries());
                try {
                  for (r.s(); !(n = r.n()).done; ) {
                    var i2 = n.value;
                    console.log("data ".concat(i2[0], ": ").concat(i2[1]));
                  }
                } catch (e2) {
                  r.e(e2);
                } finally {
                  r.f();
                }

                this.$store.cartStore.addFormDataToCart(t);
                return;
              }

              this.bundleError = "";

              if (!this.selected_variant_available) {
                return;
              }

              if (!this.allCharmsConfirmed()) {
                this.bundleError = this.bundleSelectionError();

                var firstIncompleteIndex = this.charmSelections.findIndex(function (charm) {
                  return !charm.confirmed;
                });

                if (firstIncompleteIndex > -1) {
                  this.openCharmRow(firstIncompleteIndex);
                }

                return;
              }

              var formData = new FormData(e.currentTarget);
              var bundleId = "bracelet_" + Date.now();
              var items = [
                {
                  id: Number(this.variant_id),
                  quantity: 1,
                  properties: this.buildParentProperties(formData, bundleId),
                },
              ].concat(this.buildCharmItems(bundleId));

              this.$store.cartStore.show_cart_tray = true;
              this.$store.cartStore.show_loading_item = true;
              this.$store.cartStore.showProgress();

              fetch("/cart/add.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Accept: "application/json",
                },
                body: JSON.stringify({ items: items }),
              })
                .then(function (response) {
                  if (!response.ok) {
                    return response.text().then(function (text) {
                      throw new Error(text || "Unable to add configured bracelet to cart.");
                    });
                  }
                  return response.json();
                })
                .then(
                  function () {
                    this.$store.cartStore.fetchCart(true);
                  }.bind(this)
                )
                .catch(
                  function (error) {
                    console.error("Add bundle failed:", error);
                    this.bundleError =
                      error.message || "Unable to add configured bracelet to cart.";
                    this.$store.cartStore.show_loading_item = false;
                    this.$store.cartStore.stopProgress();
                  }.bind(this)
                );
            },
            showSizeSelector__clicked: function (e) {
              e.preventDefault(),
                e.stopPropagation(),
                (this.$store.cartStore.show_size_tray = !0);
            },
            setSelectedVariantFromOptions: function (e, t, n) {
              this.selected_variant = window.STORE.product_variants.find(
                function (r) {
                  return r.option1 == e && r.option2 == t && r.option3 == n;
                }
              );
            },
            uncheckElements: function () {
              var e,
                t = o(
                  this.$el.querySelectorAll("[data-uncheck-on-variant-change]")
                );
              try {
                for (t.s(); !(e = t.n()).done; ) {
                  e.value.checked = !1;
                }
              } catch (e) {
                t.e(e);
              } finally {
                t.f();
              }
              if (document.getElementById('dependent-featured-image')) {
                document.getElementById('dependent-featured-image').scrollIntoView({ behavior: "instant"});
              }
            },
            filterDynamicDropdown: function (par) {
              var s31,
                a31 = document.getElementsByName(par),
                q31 = document.getElementsByClassName("dynamic-label");
              for (let i = 0; i < a31.length; i++) {
                if (a31[i].checked) {
                  s31 = a31[i].value;
                  break;
                }
              }
              for (let j = 0; j < q31.length; j++) {
                var s31hand = s31.replace(/\s+/g, "-").toLowerCase();
                if (!q31[j].classList.contains("ns-" + s31hand)) {
                  q31[j].classList.add("hide");
                } else if (
                  q31[j].classList.contains("ns-" + s31hand) &&
                  q31[j].classList.contains("hide")
                ) {
                  q31[j].classList.remove("hide");
                }
              }
            },
            attachmentType__Selected: function (hide, pos, par, chi) {
              var s32,
                a32 = document.getElementsByName(par),
                q32 = document.getElementsByClassName("dynamic-label"),
                r32 = document.getElementsByName(chi),
                t32 = document.getElementById("productExtraOptions"),
                //r34 = document.getElementsByName("properties[Letter]"),
                r33 = document.getElementById("variableOption");
              for (let i = 0; i < a32.length; i++) {
                if (a32[i].checked) {
                  s32 = a32[i].value;
                  break;
                }
              }
              if (r33 != null) {
                if (hide && r33.classList.contains("hide")) {
                  r33.classList.remove("hide");
                }
              }
              if (t32 != null) {
                if (hide && !t32.classList.contains("hide")) {
                  t32.classList.add("hide");
                  // for(var i=0;i<r34.length;i++) {
                  //   r34[i].checked = false;
                  // }
                }
              }
              for (let j = 0; j < q32.length; j++) {
                var s32hand = s32.replace(/\s+/g, "-").toLowerCase();
                if (!q32[j].classList.contains("ns-" + s32hand)) {
                  q32[j].classList.add("hide");
                } else if (
                  q32[j].classList.contains("ns-" + s32hand) &&
                  q32[j].classList.contains("hide")
                ) {
                  q32[j].classList.remove("hide");
                }
              }
              for (let k = r32.length - 1; k >= 0; k--) {
                let v = false;
                if (!r32[k].value.startsWith(s32)) {
                  r32[k].checked = false;
                } else if (!v) {
                  if (pos == 1) {
                    this.setSelectedVariantFromOptions(s32, r32[k].value);
                  } else if (pos == 2) {
                    this.setSelectedVariantFromOptions(
                      this.option1,
                      s32,
                      r32[k].value
                    );
                  }
                  r32[k].checked = true;
                }
              }
            },
            dynamicExtraValue__Selected: function (number) {
              var q300 = document.getElementsByClassName("productDynamicExtraOptions");
              for (let i = 0; i < q300.length; i++) {
                if (i <= number && q300[i].classList.contains("hide")) {
                  q300[i].classList.remove("hide");
                } else if (i > number && !q300[i].classList.contains("hide")) {
                  q300[i].classList.add("hide");
                }
              }
            },
            extraAttachmentType__Selected: function (pos, par, chi) {
              this.attachmentType__Selected(false, pos, par, chi);
              var q33 = document.getElementById("productExtraOptions"),
                z32 = document.getElementById("variableOption");
              if (q33.classList.contains("hide")) {
                q33.classList.remove("hide");
              }
              if (!z32.classList.contains("hide")){
                z32.classList.add("hide");
              }
            },
            setExtraOptionDefaultValues: function () {
              var e,
                t = o(this.$el.querySelectorAll("select[data-extra-option]")),
                rb = document.getElementById('show-popup-extra-item-0');
              if (rb) {
                if (rb.type == 'text') {
                  rb.value = '';
                }
              }              
              try {
                for (t.s(); !(e = t.n()).done; ) {
                  var n = e.value;
                  this.$store.cartStore[
                    "extra_option_" + n.dataset.extraOption
                  ] = n.children[0].value;
                }
              } catch (e) {
                t.e(e);
              } finally {
                t.f();
              }
              var r,
                i = o(this.$el.querySelectorAll("radio[data-extra-option]"));
              try {
                for (i.s(); !(r = i.n()).done; ) {
                  var s = r.value;
                  this.$store.cartStore[
                    "extra_option_" + s.dataset.extraOption
                  ] = s.value;
                }
              } catch (e) {
                i.e(e);
              } finally {
                i.f();
              }
            },

            bundleSelectionError: function () {
              return "Please complete all " + String(this.charmName || "Charm").toLowerCase() + " selections.";
            },

            initCharmBuilder: function () {
              var builderEl = this.$el.querySelector(".ns-charm-builder");
              var dataEl = this.$el.querySelector('[id^="CharmProductsData-"]');

              this.charmName =
                builderEl && builderEl.dataset && builderEl.dataset.charmName
                  ? builderEl.dataset.charmName
                  : "Charm";

              this.charmBuilderEnabled = !!dataEl;

              if (!this.charmBuilderEnabled) {
                this.charmProductsData = [];
                this.charmSelections = [];
                return;
              }

              this.charmProductsData = this.readCharmProductsData();
              this.materialOptionPosition = this.getMaterialOptionPosition();
              this.charmQty = Number(this.charmQty || 1);
              this.syncCharmRows();
            },

            readCharmProductsData: function () {
              var dataEl = this.$el.querySelector('[id^="CharmProductsData-"]');
              if (!dataEl) return [];

              try {
                return JSON.parse(dataEl.textContent || "[]");
              } catch (error) {
                console.error("Invalid charm products JSON", error);
                return [];
              }
            },

            getMaterialOptionPosition: function () {
              if (!window.STORE.product_options) return 1;

              for (var idx = 0; idx < window.STORE.product_options.length; idx++) {
                var optionName = String(window.STORE.product_options[idx]).toLowerCase();
                if (
                  optionName.includes("gold") ||
                  optionName.includes("metal") ||
                  optionName.includes("colour") ||
                  optionName.includes("material") ||
                  optionName.includes("color")
                ) {
                  return idx + 1;
                }
              }

              return 1;
            },

            getCurrentMaterial: function () {
              if (this.materialOptionPosition === 1) return this.option1;
              if (this.materialOptionPosition === 2) return this.option2;
              if (this.materialOptionPosition === 3) return this.option3;
              return this.option1;
            },

            availableCharmTypes: function () {
              var material = this.getCurrentMaterial();
              var seen = {};

              return this.charmProductsData
                .filter(function (product) {
                  return (product.variants || []).some(function (variant) {
                    return String(variant.options[0]) === String(material);
                  });
                })
                .map(function (product) {
                  return product.type;
                })
                .filter(function (type) {
                  if (seen[type]) return false;
                  seen[type] = true;
                  return true;
                });
            },

            charmProductForType: function (type) {
              return this.charmProductsData.find(function (product) {
                return String(product.type) === String(type);
              }) || null;
            },

            charmOptionsForType: function (type) {
              var material = this.getCurrentMaterial();
              var product = this.charmProductForType(type);
              var seen = {};

              if (!material || !product) return [];

              return (product.variants || [])
                .filter(function (variant) {
                  return String(variant.options[0]) === String(material);
                })
                .map(function (variant) {
                  return {
                    value: variant.options[1],
                    image: variant.image || "",
                    variantId: String(variant.id),
                    price: Number(variant.price || 0),
                  };
                })
                .filter(function (option) {
                  if (seen[option.value]) return false;
                  seen[option.value] = true;
                  return true;
                });
            },

            charmOptionsFor: function (index) {
              var charm = this.charmSelections[index] || {};
              return this.charmOptionsForType(charm.type);
            },

            selectedCharmOption: function (index) {
              var charm = this.charmSelections[index];
              if (!charm) return null;

              return this.charmOptionsFor(index).find(function (option) {
                return String(option.value) === String(charm.value);
              }) || null;
            },

            selectedCharmPriceCents: function (index) {
              var option = this.selectedCharmOption(index);
              return option ? Number(option.price || 0) : 0;
            },

            selectedCharmTotalCents: function () {
              var total = 0;

              if (!this.charmBuilderEnabled) return total;

              for (var i3 = 0; i3 < this.charmSelections.length; i3++) {
                total += this.selectedCharmPriceCents(i3);
              }

              return total;
            },

            resetCharmValue: function (index) {
              var options = this.charmOptionsFor(index);
              if (!this.charmSelections[index]) return;

              this.charmSelections = this.charmSelections.map(function (charm, i3) {
                if (i3 === index) {
                  return {
                    type: charm.type,
                    value: options.length ? options[0].value : "",
                    confirmed: false,
                    expanded: true,
                  };
                }

                return {
                  type: charm.type,
                  value: charm.value,
                  confirmed: charm.confirmed,
                  expanded: false,
                };
              });
            },

            allCharmsConfirmed: function () {
              if (!this.charmBuilderEnabled) return true;
              if (!this.charmSelections.length) return false;

              return this.charmSelections.every(function (charm) {
                return charm.confirmed && charm.value;
              });
            },

            openCharmRow: function (index) {
              this.charmSelections = this.charmSelections.map(function (charm, i3) {
                return {
                  type: charm.type,
                  value: charm.value,
                  confirmed: charm.confirmed,
                  expanded: i3 === index,
                };
              });

              this.$nextTick(function () {
                var row = document.getElementById("charm-row-" + index);
                if (row) {
                  row.scrollIntoView({ behavior: "smooth", block: "nearest" });
                }
              });
            },

            toggleCharmRow: function (index) {
              if (!this.charmSelections[index]) return;

              var isOpen = !!this.charmSelections[index].expanded;

              if (isOpen && this.charmSelections[index].confirmed) {
                this.charmSelections = this.charmSelections.map(function (charm) {
                  return {
                    type: charm.type,
                    value: charm.value,
                    confirmed: charm.confirmed,
                    expanded: false,
                  };
                });
                return;
              }

              this.openCharmRow(index);
            },

            syncCharmRows: function () {
              if (!this.charmBuilderEnabled) return;

              var qty = Number(this.charmQty) || 1;
              var types = this.availableCharmTypes();
              var existingSelections = this.charmSelections || [];
              var nextSelections = [];
              var preservedOpenIndex = existingSelections.findIndex(function (charm) {
                return charm.expanded;
              });

              for (var i3 = 0; i3 < qty; i3++) {
                var existing = existingSelections[i3] || {};
                var type =
                  existing.type && types.includes(existing.type)
                    ? existing.type
                    : (types[0] || "");
                var options = this.charmOptionsForType(type);
                var optionValues = options.map(function (option) {
                  return option.value;
                });
                var value =
                  existing.value && optionValues.includes(existing.value)
                    ? existing.value
                    : (options[0] ? options[0].value : "");

                nextSelections.push({
                  type: type,
                  value: value,
                  confirmed: existing.confirmed === true && !!value,
                  expanded: false,
                });
              }

              var openIndex = -1;

              if (
                preservedOpenIndex > -1 &&
                preservedOpenIndex < nextSelections.length &&
                !nextSelections[preservedOpenIndex].confirmed
              ) {
                openIndex = preservedOpenIndex;
              } else {
                openIndex = nextSelections.findIndex(function (charm) {
                  return !charm.confirmed;
                });
              }

              if (openIndex > -1) {
                nextSelections[openIndex].expanded = true;
              }

              this.charmSelections = nextSelections;
            },

            findCharmVariant: function (type, value) {
              var material = this.getCurrentMaterial();
              var product = this.charmProductForType(type);

              if (!material || !product) return null;

              return (product.variants || []).find(function (variant) {
                return (
                  String(variant.options[0]) === String(material) &&
                  String(variant.options[1]) === String(value)
                );
              }) || null;
            },

            buildParentProperties: function (formData, bundleId) {
              var properties = {};

              for (var pair of formData.entries()) {
                var key = pair[0];
                var value = pair[1];

                if (key.indexOf("properties[") === 0 && key.slice(-1) === "]" && value !== "") {
                  var propertyName = key.replace(/^properties\[/, "").replace(/\]$/, "");
                  properties[propertyName] = value;
                }
              }

              var bundleLabel = String(this.charmName || "Charm").trim();
              var bundleLabelPlural = String(this.charmNamePlural || (bundleLabel + "s")).trim();

              properties[bundleLabel + " Qty"] = String(this.charmQty);
              properties["_bundle_label"] = bundleLabel;
              properties["_bundle_label_plural"] = bundleLabelPlural;
              properties["_bundle_id"] = bundleId;
              properties["_bundle_role"] = "parent";

              this.charmSelections.forEach(function (charm, index) {
                properties[bundleLabel + " " + (index + 1)] = charm.type + ": " + charm.value;
              });

              return properties;
            },

            buildCharmItems: function (bundleId) {
              var items = [];

              this.charmSelections.forEach(
                function (charm, index) {
                  if (!charm.type || !charm.value || !charm.confirmed) {
                    throw new Error("Please complete all charm selections.");
                  }

                  var variant = this.findCharmVariant(charm.type, charm.value);

                  if (!variant) {
                    throw new Error(
                      "Missing charm variant for " + charm.type + " / " + charm.value + "."
                    );
                  }

                  items.push({
                    id: Number(variant.id),
                    quantity: 1,
                    properties: {
                      _bundle_id: bundleId,
                      _bundle_role: "charm",
                      _slot: String(index + 1),
                    },
                  });
                }.bind(this)
              );

              return items;
            },

            selectCharm: function (index, value) {
              if (!this.charmSelections[index]) return;

              var nextSelections = this.charmSelections.map(function (charm) {
                return {
                  type: charm.type,
                  value: charm.value,
                  confirmed: charm.confirmed,
                  expanded: charm.expanded,
                };
              });

              nextSelections[index].value = value;
              nextSelections[index].confirmed = true;
              nextSelections[index].expanded = false;

              var nextUnconfirmedIndex = -1;

              for (var i3 = index + 1; i3 < nextSelections.length; i3++) {
                if (!nextSelections[i3].confirmed) {
                  nextUnconfirmedIndex = i3;
                  break;
                }
              }

              nextSelections.forEach(function (charm, i4) {
                charm.expanded = i4 === nextUnconfirmedIndex;
              });

              this.charmSelections = nextSelections;
            },
            backgroundClickCatcher__clicked: function (e) {
              this.uncheckElements();
            },
            toggleEnquiryFrom__clicked: function () {
              this.$store.cartStore.show_quote_form =
                !this.$store.cartStore.show_quote_form;
            },
          };
        }
      },
      644: function (e, t, n) {
        "use strict";
        function r(e, t) {
          var n =
            ("undefined" != typeof Symbol && e[Symbol.iterator]) ||
            e["@@iterator"];
          if (!n) {
            if (
              Array.isArray(e) ||
              (n = (function (e, t) {
                if (!e) return;
                if ("string" == typeof e) return i(e, t);
                var n = Object.prototype.toString.call(e).slice(8, -1);
                "Object" === n && e.constructor && (n = e.constructor.name);
                if ("Map" === n || "Set" === n) return Array.from(e);
                if (
                  "Arguments" === n ||
                  /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
                )
                  return i(e, t);
              })(e)) ||
              (t && e && "number" == typeof e.length)
            ) {
              n && (e = n);
              var r = 0,
                o = function () {};
              return {
                s: o,
                n: function () {
                  return r >= e.length
                    ? { done: !0 }
                    : { done: !1, value: e[r++] };
                },
                e: function (e) {
                  throw e;
                },
                f: o,
              };
            }
            throw new TypeError(
              "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
            );
          }
          var s,
            a = !0,
            c = !1;
          return {
            s: function () {
              n = n.call(e);
            },
            n: function () {
              var e = n.next();
              return (a = e.done), e;
            },
            e: function (e) {
              (c = !0), (s = e);
            },
            f: function () {
              try {
                a || null == n.return || n.return();
              } finally {
                if (c) throw s;
              }
            },
          };
        }
        function i(e, t) {
          (null == t || t > e.length) && (t = e.length);
          for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
          return r;
        }
        function o() {
          return {
            error_message: "",
            has_form_been_submitted: !1,
            success_html: "",
            close__clicked: function (e) {
              this.$store.cartStore.show_quote_form = !1;
            },
            input__changed: function (e) {
              this.error_message = "";
              var t,
                n = r(this.$el.querySelectorAll(".error"));
              try {
                for (n.s(); !(t = n.n()).done; ) {
                  t.value.classList.remove("error");
                }
              } catch (e) {
                n.e(e);
              } finally {
                n.f();
              }
            },
            quoteFrom__submitted: function (e) {
              var t = this,
                n = new FormData(e.currentTarget),
                r = null;
              n.get("additional_data[name]").length < 1
                ? ((r = "name"), (this.error_message = "Name required"))
                : n.get("additional_data[email]").length < 1
                ? ((r = "email"), (this.error_message = "Email required"))
                : n.get("additional_data[text-1600942966831]").length < 1
                ? ((r = "text-1600942966831"),
                  (this.error_message = "Budget required"))
                : n.get("additional_data[message]").length < 1 &&
                  ((r = "message"), (this.error_message = "Message required")),
                r
                  ? e.currentTarget
                      .querySelector(
                        'input[name="additional_data['.concat(r, ']"]')
                      )
                      .parentElement.classList.add("error")
                  : fetch(e.currentTarget.action, { method: "post", body: n })
                      .then(function (e) {
                        return e.json();
                      })
                      .then(function (e) {
                        console.log("res", e),
                          e.success
                            ? ((t.has_form_been_submitted = !0),
                              (t.success_html = e.html))
                            : (t.error_message =
                                "Error occurred. Please contact a store");
                      })
                      .catch(function (e) {
                        console.log("error", e);
                      });
            },
          };
        }
        n.r(t),
          n.d(t, {
            default: function () {
              return o;
            },
          });
      },
      164: function (e, t, n) {
        "use strict";
        function r() {
          return {
            recentlyViewedProductsKey: "recently_viewed_products",
            recentlyViewedProducts: [],
            hasPendingRequest: !1,
            nextPage: 1,
            offset: 24,
            paginationObserver: null,
            addToRecentlyViewed: function (e) {
              var t = this.recentlyViewedProductIds;
              console.log("addToRecentlyViewed", JSON.stringify(t)),
                t
                  ? (t.includes(e) && t.splice(t.indexOf(e), 1), t.push(e))
                  : (t = [e]),
                this.saveRecentlyViewedToLocalStorage(t);
            },
            saveRecentlyViewedToLocalStorage: function (e) {
              localStorage.setItem(
                this.recentlyViewedProductsKey,
                JSON.stringify(e)
              );
            },
            initResults: function () {
              this.setPaginationObserver();
            },
            get recentlyViewedProductIds() {
              var e = localStorage.getItem(this.recentlyViewedProductsKey);
              return null == e ? [] : JSON.parse(e).reverse();
            },
            get nextRecentlyViewedProductIds() {
              return this.recentlyViewedProductIds.slice(
                (this.nextPage - 1) * this.offset,
                this.nextPage * this.offset
              );
            },
            get graphQLProductsVariables() {
              return {
                ids: this.nextRecentlyViewedProductIds.map(function (e) {
                  return "gid://shopify/Product/".concat(e);
                }),
              };
            },
            get graphQLProductsQuery() {
              return "\n                query ($ids: [ID!]!) {\n                    nodes(ids: $ids) {\n                        ... on Product {\n                            id\n                            title\n                            handle\n                            availableForSale\n                            images(first: 2) {\n                                edges {\n                                    node {\n                                        transformedSrc(maxWidth: 800)\n                                    }\n                                }\n                            }\n                            variants(first: 20) {\n                                edges {\n                                    node {\n                                        id\n                                        title\n                                        priceV2 {\n                                        amount\n                                        }\n                                        availableForSale\n                                    }\n                                }\n                            }\n                        }\n                    }\n                }\n            ";
            },
            get graphQLProductsRequestBody() {
              return {
                variables: this.graphQLProductsVariables,
                query: this.graphQLProductsQuery,
              };
            },
            setRecentlyViewedProducts: function (e) {
              this.recentlyViewedProducts = this.recentlyViewedProducts.concat(
                e.filter(function (e) {
                  return e;
                })
              );
            },
            fetchRecentlyViewedProducts: function () {
              var e = this;
              if (
                this.hasPendingRequest ||
                this.nextRecentlyViewedProductIds.length <= 0
              )
                return !1;
              (this.hasPendingRequest = !0),
                Api.graphQLPostRequest(this.graphQLProductsRequestBody).then(
                  function (t) {
                    e.setRecentlyViewedProducts(t.data.nodes),
                      (e.hasPendingRequest = !1),
                      e.nextPage++;
                  }
                );
            },
            paginationObserverCallBack: function (e) {
              var t = this;
              e.forEach(function (e) {
                e.isIntersecting && t.fetchRecentlyViewedProducts();
              });
            },
            setPaginationObserver: function () {
              this.paginationObserver ||
                (this.paginationObserver = new IntersectionObserver(
                  this.paginationObserverCallBack.bind(this),
                  {}
                )),
                this.paginationObserver.observe(
                  this.$el.querySelector("[data-pagination-observer]")
                );
            },
            addToCart__clicked: function (e) {
              this.$store.cartStore.addToCart(
                Utils.decodeStoreFrontApiVariantId(e)
              );
            },
          };
        }
        n.r(t),
          n.d(t, {
            default: function () {
              return r;
            },
          });
      },
      294: function (e, t, n) {
        "use strict";
        n.r(t),
          n.d(t, {
            default: function () {
              return s;
            },
          });
        var r = n(785);
        function i(e, t) {
          var n =
            ("undefined" != typeof Symbol && e[Symbol.iterator]) ||
            e["@@iterator"];
          if (!n) {
            if (
              Array.isArray(e) ||
              (n = (function (e, t) {
                if (!e) return;
                if ("string" == typeof e) return o(e, t);
                var n = Object.prototype.toString.call(e).slice(8, -1);
                "Object" === n && e.constructor && (n = e.constructor.name);
                if ("Map" === n || "Set" === n) return Array.from(e);
                if (
                  "Arguments" === n ||
                  /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
                )
                  return o(e, t);
              })(e)) ||
              (t && e && "number" == typeof e.length)
            ) {
              n && (e = n);
              var r = 0,
                i = function () {};
              return {
                s: i,
                n: function () {
                  return r >= e.length
                    ? { done: !0 }
                    : { done: !1, value: e[r++] };
                },
                e: function (e) {
                  throw e;
                },
                f: i,
              };
            }
            throw new TypeError(
              "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
            );
          }
          var s,
            a = !0,
            c = !1;
          return {
            s: function () {
              n = n.call(e);
            },
            n: function () {
              var e = n.next();
              return (a = e.done), e;
            },
            e: function (e) {
              (c = !0), (s = e);
            },
            f: function () {
              try {
                a || null == n.return || n.return();
              } finally {
                if (c) throw s;
              }
            },
          };
        }
        function o(e, t) {
          (null == t || t > e.length) && (t = e.length);
          for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
          return r;
        }
        function s() {
          return {
            visibleIndexArray: [],
            current_index: 0,
            observer: null,
            pagination_container: null,
            load_offset: 0,
            init: function (e) {
              e.loadOffset && (this.load_offset = e.loadOffset),
                (this.observer = new IntersectionObserver(
                  this.intersectObserver__itemVisibilityChanged.bind(this),
                  { root: this.$refs.scroll_container, threshold: 0.3 }
                ));
              for (
                var t = 0, n = Array.from(this.$refs.scroll_container.children);
                t < n.length;
                t++
              ) {
                var r = n[t];
                this.observer.observe(r), this.addPaginationDot();
              }
            },
            addPaginationDot: function () {
              var e = document.createElement("div");
              e.classList.add("scroll-pagination__dot"),
                this.$refs.pagination_container.appendChild(e);
            },
            intersectObserver__itemVisibilityChanged: function (e) {
              var t = this;
              e.forEach(function (e) {
                var n = e.target.parentNode.children;
                (t.current_index = Array.from(n).indexOf(e.target)),
                  e.isIntersecting
                    ? ((t.$el.dataset.activeIndex = t.current_index),
                      t.visibleIndexArray.includes(t.current_index) ||
                        t.visibleIndexArray.push(t.current_index),
                      t.current_index >= t.load_offset && t.loadSrcSets(e))
                    : t.visibleIndexArray.includes(t.current_index) &&
                      t.visibleIndexArray.splice(
                        t.visibleIndexArray.indexOf(t.current_index),
                        1
                      );
              });
            },
            loadSrcSets: function (e) {
              var t,
                n = i(e.target.parentNode.querySelectorAll("[data-srcset]"));
              try {
                for (n.s(); !(t = n.n()).done; ) {
                  var r = t.value;
                  (r.srcset = r.dataset.srcset),
                    r.removeAttribute("data-srcset");
                }
              } catch (e) {
                n.e(e);
              } finally {
                n.f();
              }
              var o,
                s = i(e.target.parentNode.querySelectorAll("[data-src]"));
              try {
                var a = function () {
                  var e = o.value;
                  e.classList.contains("unloaded") &&
                    (e.onload = function () {
                      e.classList.remove("unloaded");
                    }),
                    (e.src = e.dataset.src),
                    e.removeAttribute("data-src");
                };
                for (s.s(); !(o = s.n()).done; ) a();
              } catch (e) {
                s.e(e);
              } finally {
                s.f();
              }
            },
            showNextItem__clicked: function (e) {
              e.preventDefault();
              var t = Math.min.apply(Math, (0, r.Z)(this.visibleIndexArray));
              this.scrollToChild(t + 1);
            },
            showPreviousItem__clicked: function (e) {
              e.preventDefault();
              var t = Math.min.apply(Math, (0, r.Z)(this.visibleIndexArray));
              this.scrollToChild(t - 1);
            },
            scrollToChild: function (e) {
              var t = this.$refs.scroll_container,
                n = t.getBoundingClientRect();
              if ((console.log("index", e), e >= 0 && e < t.children.length)) {
                var r = t.children.item(e).getBoundingClientRect();
                t.scroll({
                  left: r.left - n.left + t.scrollLeft,
                  behavior: "smooth",
                });
              }
            },
            addToCart__clicked: function (e) {
              var t =
                arguments.length > 1 && void 0 !== arguments[1]
                  ? arguments[1]
                  : {};
              this.$store.cartStore.addToCart(e, t);
            },
          };
        }
      },
      289: function (e, t, n) {
        "use strict";
        function r() {
          return {
            results: [],
            search_query: "",
            has_pending_request: !1,
            timer: null,
            get showResults() {
              return !!this.results.length || this.showLoader;
            },
            get showLoader() {
              return this.has_pending_request;
            },
            get triggerSearch() {
              return !this.has_pending_request && this.search_query.length > 2;
            },
            init: function () {
              this.$watch("search_query", this.setSearchQueue.bind(this));
            },
            setSearchQueue: function () {
              this.timer && clearTimeout(this.timer),
                (this.timer = setTimeout(this.searchProducts.bind(this), 300));
            },
            searchProducts: function () {
              var e = this;
              this.clearResults(),
                this.triggerSearch &&
                  ((this.has_pending_request = !0),
                  Api.searchProducts(this.search_query).then(function (t) {
                    (e.results = t),
                      (e.timer = null),
                      (e.has_pending_request = !1);
                  }));
            },
            clearResults: function () {
              this.results = [];
            },
          };
        }
        n.r(t),
          n.d(t, {
            default: function () {
              return r;
            },
          });
      },
      815: function (e, t, n) {
        "use strict";
        function r(e, t, n) {
          return (
            t in e
              ? Object.defineProperty(e, t, {
                  value: n,
                  enumerable: !0,
                  configurable: !0,
                  writable: !0,
                })
              : (e[t] = n),
            e
          );
        }
        n.r(t),
          n.d(t, {
            default: function () {
              return c;
            },
          });
        var i = n(592),
          o = n.n(i);
        function s(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t &&
              (r = r.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })),
              n.push.apply(n, r);
          }
          return n;
        }
        function a(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2
              ? s(Object(n), !0).forEach(function (t) {
                  r(e, t, n[t]);
                })
              : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
              : s(Object(n)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(n, t)
                  );
                });
          }
          return e;
        }
        function c() {
          return {
            sizes: [
              { name: "D", usa: "2", mm: 41.6, inch: 1.64 },
              { name: "D 1/2", usa: "2", mm: 42.3, inch: 1.66 },
              { name: "E", usa: "2.5", mm: 42.9, inch: 1.69 },
              { name: "E 1/2", usa: "2.5", mm: 43.5, inch: 1.71 },
              { name: "F", usa: "3", mm: 44, inch: 1.73 },
              { name: "F 1/2", usa: "3", mm: 44.2, inch: 1.74 },
              { name: "G", usa: "3.5", mm: 44.8, inch: 1.77 },
              { name: "G 1/2", usa: "3.5", mm: 45.5, inch: 1.79 },
              { name: "H", usa: "3.5", mm: 46.1, inch: 1.82 },
              { name: "H 1/2", usa: "4", mm: 46.8, inch: 1.84 },
              { name: "I", usa: "4", mm: 47.4, inch: 1.87 },
              { name: "I 1/2", usa: "4.5", mm: 48, inch: 1.89 },
              { name: "J", usa: "4.5", mm: 48.7, inch: 1.92 },
              { name: "J 1/2", usa: "5", mm: 49.3, inch: 1.94 },
              { name: "K", usa: "5", mm: 50, inch: 1.97 },
              { name: "K 1/2", usa: "5.5", mm: 50.6, inch: 1.99 },
              { name: "L", usa: "5.5", mm: 51.2, inch: 2.02 },
              { name: "L 1/2", usa: "6", mm: 51.9, inch: 2.04 },
              { name: "M", usa: "6", mm: 52.5, inch: 2.07 },
              { name: "M 1/2", usa: "6.5", mm: 53.1, inch: 2.09 },
              { name: "N", usa: "6.5", mm: 53.8, inch: 2.12 },
              { name: "N 1/2", usa: "7", mm: 54.4, inch: 2.14 },
              { name: "O", usa: "7", mm: 55.1, inch: 2.17 },
              { name: "O 1/2", usa: "7.5", mm: 55.7, inch: 2.19 },
              { name: "P", usa: "7.5", mm: 56.3, inch: 2.22 },
              { name: "P 1/2", usa: "8", mm: 57, inch: 2.24 },
              { name: "Q", usa: "8", mm: 57.6, inch: 2.27 },
              { name: "Q 1/2", usa: "8.5", mm: 58.3, inch: 2.29 },
              { name: "R", usa: "8.5", mm: 58.9, inch: 2.32 },
              { name: "R 1/2", usa: "9", mm: 59.5, inch: 2.34 },
              { name: "TBC", usa: "TBC", mm: 0, inch: 0 },
            ],
            displayed_sizes: [],
            size_option_name: null,
            size_option_index: 0,
            init: function () {
              var e = this;
              (this.$store.cartStore.size_country_selection = "usa"),
                this.setSizeOptionName(),
                this.is_initialized && this.update_displayed_sizes(),
                o().watch("cartStore", function (t, n) {
                  "selected_variant" == n && e.update_displayed_sizes();
                });
            },
            get selected_variant() {
              return this.$store.cartStore.selected_variant;
            },
            get show_size_tray() {
              return (
                this.is_initialized && this.$store.cartStore.show_size_tray
              );
            },
            get is_initialized() {
              return null != this.size_option_name;
            },
            get selected_country() {
              return this.$store.cartStore.size_country_selection;
            },
            close: function () {
              this.$store.cartStore.show_size_tray = !1;
            },
            setSizeOptionName: function () {
              if (
                null == window.STORE.product_options &&
                null == window.STORE.product_variants
              )
                return (
                  (this.size_option_name = "not set"),
                  void (this.displayed_sizes = this.sizes.map(function (e) {
                    return a(a({}, e), {}, { available: !0 });
                  }))
                );
              for (var e = 0; e < window.STORE.product_options.length; e++)
                if (
                  window.STORE.product_options[e]
                    .toLowerCase()
                    .includes("ring size")
                ) {
                  (this.size_option_name = "option" + (e + 1)),
                    (this.size_option_index = e);
                  break;
                };
              if (this.size_option_name == null) { 
                return (
                  (this.size_option_name = "not set"),
                  void (this.displayed_sizes = this.sizes.map(function (e) {
                    return a(a({}, e), {}, { available: !0 });
                  }))
                );
              }
              console.log(
                "setSizeOptionName",
                this.size_option_name,
                window.STORE.product_variants[0][this.size_option_name]
              ),
                console.log("example", window.STORE.product_variants[0]);
            },
            update_displayed_sizes: function () {
              if (this.size_option_name != null && this.size_option_name != "not set" ) {
                var e = this;
                null != window.STORE.product_variants &&
                  (this.displayed_sizes = this.sizes.reduce(function (t, n) {
                    var r = e.findMethod(n, e.$store.cartStore.selected_variant),
                      i = window.STORE.product_variants.find(function (e) {
                        return r(e);
                      });
                    return (
                      i &&
                        ((n.variant_id = i.id),
                        (n.option_value = i[e.size_option_name]),
                        (n.available = i.available),
                        t.push(n)),
                      t
                    );
                  }, [])); 
              }
            },
            selectCountry__clicked: function (e) {
              (this.$store.cartStore.size_country_selection = e),
                (this.$refs.country_selector.checked = !1);
            },
            selectSize__clicked: function (e) {
              console.log(e);
              null != window.STORE.product_variants &&
                (e.available
                  ? (console.log(
                      "Size",
                      e.name,
                      e.option_value,
                      e.available,
                      e.variant_id
                    ),
                    (this.$store.cartStore.selected_variant =
                      window.STORE.product_variants.find(
                        this.selectionMethod(
                          e,
                          this.$store.cartStore.selected_variant
                        )
                      )),
                    (this.$store.cartStore.show_size_tray = !1))
                  : (this.$store.cartStore.selected_variant =
                      window.STORE.product_variants.find(
                        this.selectionMethod(
                          e,
                          this.$store.cartStore.selected_variant
                        )
                      )),
                     (this.$store.cartStore.show_size_tray = !1));
            },
            selectionMethod: function (e, t) {
              return "option1" == this.size_option_name
                ? function (n) {
                    return (
                      n.option1 == e.option_value &&
                      n.option2 == t.option2 &&
                      n.option3 == t.option3
                    );
                  }
                : "option2" == this.size_option_name
                ? function (n) {
                    return (
                      n.option1 == t.option1 &&
                      n.option2 == e.option_value &&
                      n.option3 == t.option3
                    );
                  }
                : function (n) {
                    return (
                      n.option1 == t.option1 &&
                      n.option2 == t.option2 &&
                      n.option3 == e.option_value
                    );
                  };
            },
            findMethod: function (e, t) {
              return "option1" == this.size_option_name
                ? function (n) {
                    return (
                      n.option1.toLowerCase() == e.name.toLowerCase() &&
                      n.option2 == t.option2 &&
                      n.option3 == t.option3
                    );
                  }
                : "option2" == this.size_option_name
                ? function (n) {
                    return (
                      n.option1 == t.option1 &&
                      n.option2 == e.name &&
                      n.option3 == t.option3
                    );
                  }
                : function (n) {
                    return (
                      n.option1 == t.option1 &&
                      n.option2 == t.option2 &&
                      n.option3 == e.name
                    );
                  };
            },
          };
        }
      },
      194: function (e, t, n) {
        "use strict";
        function r(e, t) {
          var n =
            ("undefined" != typeof Symbol && e[Symbol.iterator]) ||
            e["@@iterator"];
          if (!n) {
            if (
              Array.isArray(e) ||
              (n = (function (e, t) {
                if (!e) return;
                if ("string" == typeof e) return i(e, t);
                var n = Object.prototype.toString.call(e).slice(8, -1);
                "Object" === n && e.constructor && (n = e.constructor.name);
                if ("Map" === n || "Set" === n) return Array.from(e);
                if (
                  "Arguments" === n ||
                  /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
                )
                  return i(e, t);
              })(e)) ||
              (t && e && "number" == typeof e.length)
            ) {
              n && (e = n);
              var r = 0,
                o = function () {};
              return {
                s: o,
                n: function () {
                  return r >= e.length
                    ? { done: !0 }
                    : { done: !1, value: e[r++] };
                },
                e: function (e) {
                  throw e;
                },
                f: o,
              };
            }
            throw new TypeError(
              "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
            );
          }
          var s,
            a = !0,
            c = !1;
          return {
            s: function () {
              n = n.call(e);
            },
            n: function () {
              var e = n.next();
              return (a = e.done), e;
            },
            e: function (e) {
              (c = !0), (s = e);
            },
            f: function () {
              try {
                a || null == n.return || n.return();
              } finally {
                if (c) throw s;
              }
            },
          };
        }
        function i(e, t) {
          (null == t || t > e.length) && (t = e.length);
          for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
          return r;
        }
        function o() {
          return {
            sticky_item_elements: [],
            pagination_dot_elements: [],
            scrolling_elements_observer: null,
            sticky_elements_observer: null,
            init: function (e) {
              (this.sticky_item_elements = this.$refs.sticky_items.children),
                (this.scrolling_elements_observer = new IntersectionObserver(
                  this.scrollingItem__intersected.bind(this),
                  { root: null, threshold: 0.1 }
                )),
                (this.sticky_elements_observer = new IntersectionObserver(
                  this.stickyItem__intersected.bind(this),
                  { root: null, threshold: 0.6 }
                ));
              var t,
                n = r(this.sticky_item_elements);
              try {
                for (n.s(); !(t = n.n()).done; ) {
                  var i = t.value;
                  this.createScrollingElement(),
                    this.createPaginationDot(),
                    this.sticky_elements_observer.observe(i);
                }
              } catch (e) {
                n.e(e);
              } finally {
                n.f();
              }
              this.preloadVariantImagesIfRequired();
            },
            createScrollingElement: function () {
              var e = document.createElement("div");
              e.classList.add("sticky-section__scrolling-item"),
                this.scrolling_elements_observer.observe(e),
                this.$refs.scrolling_items.appendChild(e);
            },
            createPaginationDot: function () {
              var e = document.createElement("div");
              e.classList.add("pagination-dot"),
                this.$refs.pagination_items.appendChild(e),
                this.pagination_dot_elements.push(e);
            },
            preloadVariantImagesIfRequired: function () {
              if (window.STORE.product_has_variant_dependent_images) {
                var e,
                  t = r(window.STORE.product_variants);
                try {
                  for (t.s(); !(e = t.n()).done; ) {
                    var n = e.value;
                    if (n.featured_image && n.featured_image.src) {
                      new Image().src = n.featured_image.src.replace(".jpg", "_1200x.jpg");
                    }
                  }
                } catch (e) {
                  t.e(e);
                } finally {
                  t.f();
                }
              }
            },
            get selected_variant_image_url() {
              return this.$store.cartStore.selected_variant &&
                this.$store.cartStore.selected_variant.featured_image &&
                this.$store.cartStore.selected_variant.featured_image.src
                ? this.$store.cartStore.selected_variant.featured_image.src.replace(".jpg", "_1200x.jpg")
                : "";
            },
          };
        }
        n.r(t),
          n.d(t, {
            default: function () {
              return o;
            },
          });
      },
      7: function (e, t, n) {
        "use strict";
        function r(e, t) {
          var n =
            ("undefined" != typeof Symbol && e[Symbol.iterator]) ||
            e["@@iterator"];
          if (!n) {
            if (
              Array.isArray(e) ||
              (n = (function (e, t) {
                if (!e) return;
                if ("string" == typeof e) return i(e, t);
                var n = Object.prototype.toString.call(e).slice(8, -1);
                "Object" === n && e.constructor && (n = e.constructor.name);
                if ("Map" === n || "Set" === n) return Array.from(e);
                if (
                  "Arguments" === n ||
                  /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
                )
                  return i(e, t);
              })(e)) ||
              (t && e && "number" == typeof e.length)
            ) {
              n && (e = n);
              var r = 0,
                o = function () {};
              return {
                s: o,
                n: function () {
                  return r >= e.length
                    ? { done: !0 }
                    : { done: !1, value: e[r++] };
                },
                e: function (e) {
                  throw e;
                },
                f: o,
              };
            }
            throw new TypeError(
              "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
            );
          }
          var s,
            a = !0,
            c = !1;
          return {
            s: function () {
              n = n.call(e);
            },
            n: function () {
              var e = n.next();
              return (a = e.done), e;
            },
            e: function (e) {
              (c = !0), (s = e);
            },
            f: function () {
              try {
                a || null == n.return || n.return();
              } finally {
                if (c) throw s;
              }
            },
          };
        }
        function i(e, t) {
          (null == t || t > e.length) && (t = e.length);
          for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
          return r;
        }
        function o() {
          return {
            sticky_item_elements: [],
            pagination_dot_elements: [],
            scrolling_elements_observer: null,
            sticky_elements_observer: null,
            is_sticky_section: !0,
            init: function (e) {
              if (
                ((this.is_sticky_section = e.is_sticky_section),
                this.is_sticky_section)
              ) {
                (this.sticky_item_elements = this.$refs.sticky_items.children),
                  (this.scrolling_elements_observer = new IntersectionObserver(
                    this.scrollingItem__intersected.bind(this),
                    { root: null, threshold: 0.1 }
                  )),
                  (this.sticky_elements_observer = new IntersectionObserver(
                    this.stickyItem__intersected.bind(this),
                    { root: null, threshold: 0.6 }
                  ));
                var t,
                  n = r(this.sticky_item_elements);
                try {
                  for (n.s(); !(t = n.n()).done; ) {
                    var i = t.value;
                    this.createScrollingElement(),
                      this.createPaginationDot(),
                      this.sticky_elements_observer.observe(i);
                  }
                } catch (e) {
                  n.e(e);
                } finally {
                  n.f();
                }
              } else {
                var o = this.$refs.images.children;
                this.sticky_elements_observer = new IntersectionObserver(
                  this.stickyItem__intersected.bind(this),
                  { root: null, threshold: 0.6 }
                );
                var s,
                  a = r(o);
                try {
                  for (a.s(); !(s = a.n()).done; ) {
                    var c = s.value;
                    this.createPaginationDot(),
                      this.sticky_elements_observer.observe(c);
                  }
                } catch (e) {
                  a.e(e);
                } finally {
                  a.f();
                }
              }
              const galleryImages = document.querySelectorAll('.product-simple__image-item');
              const options = {
                  root: null,
                  threshold: 0.5
              }
              const observer = new IntersectionObserver(function(entries, observer) {
                  entries.forEach(entry => {
                      if (entry.isIntersecting) {
                          var rb20 = document.getElementsByClassName("product-simple__thumbnail");
                          for (let i = 0; i < rb20.length; i++) {
                            if (rb20[i].id === "tn-" + entry.target.id) {
                              rb20[i].classList.remove("dim")
                            } else if (!rb20[i].classList.contains("dim")) {
                              rb20[i].classList.add("dim")
                            }
                          }
                          // this.updateThumbnail(entry.target.id);
                      } else {
                          return;
                      }
                  });
              }, options);

              galleryImages.forEach(image => observer.observe(image));
              this.preloadVariantImagesIfRequired();
            },
            createScrollingElement: function () {
              var e = document.createElement("div");
              e.classList.add("sticky-section__scrolling-item"),
                this.scrolling_elements_observer.observe(e),
                this.$refs.scrolling_items.appendChild(e);
            },
            createPaginationDot: function () {
              var e = document.createElement("div");
              e.classList.add("pagination-dot"),
                this.$refs.pagination_items.appendChild(e),
                this.pagination_dot_elements.push(e);
            },
            scrollingItem__intersected: function (e, t) {
              var n = this;
              e.forEach(function (e) {
                if (e.isIntersecting) {
                  var t = e.target.parentNode.children,
                    r = Array.from(t).indexOf(e.target);
                  n.setActiveStickyItem(r), n.setActivePaginationDot(r);
                }
              });
            },
            stickyItem__intersected: function (e, t) {
              var n = this;
              e.forEach(function (e) {
                if (e.isIntersecting) {
                  var t = e.target.parentNode.children,
                    r = Array.from(t).indexOf(e.target);
                  n.setActivePaginationDot(r);
                }
              });
            },
            setActiveStickyItem: function (e) {
              var t,
                n = r(this.sticky_item_elements);
              try {
                for (n.s(); !(t = n.n()).done; ) {
                  var i = t.value;
                  i.classList.remove("previous-active"),
                    i.classList.remove("active");
                }
              } catch (e) {
                n.e(e);
              } finally {
                n.f();
              }
              this.sticky_item_elements[e].classList.add("active"),
                e > 0 &&
                  this.sticky_item_elements[e - 1].classList.add(
                    "previous-active"
                  );
            },
            setActivePaginationDot: function (e) {
              var t,
                n = r(this.pagination_dot_elements);
              try {
                for (n.s(); !(t = n.n()).done; ) {
                  t.value.classList.remove("active");
                }
              } catch (e) {
                n.e(e);
              } finally {
                n.f();
              }
              this.pagination_dot_elements[e].classList.add("active");
            },
            preloadVariantImagesIfRequired: function () {
              if (window.STORE.product_has_variant_dependent_images) {
                var e,
                  t = r(window.STORE.product_variants);
                try {
                  for (t.s(); !(e = t.n()).done; ) {
                    var n = e.value;
                    if (n.featured_image && n.featured_image.src) {
                      new Image().src = n.featured_image.src.replace(".jpg", "_1200x.jpg");
                    }
                  }
                } catch (e) {
                  t.e(e);
                } finally {
                  t.f();
                }
              }
            },
            get selected_variant_image_url() {
              return this.$store.cartStore.selected_variant &&
                this.$store.cartStore.selected_variant.featured_image &&
                this.$store.cartStore.selected_variant.featured_image.src
                ? this.$store.cartStore.selected_variant.featured_image.src.replace(".jpg", "_1200x.jpg")
                : "";
            },
            updateThumbnail: function (id) {
              var rb20 = document.getElementsByClassName("product-simple__thumbnail");
              for (let i = 0; i < rb20.length; i++) {
                if (rb20[i].id === "tn-" + id) {
                  rb20[i].classList.remove("dim")
                } else if (!rb20[i].classList.contains("dim")) {
                  rb20[i].classList.add("dim")
                }
              }
            },
            scrollTo: function (e) {
              document
                .getElementById(e)
                .scrollIntoView({ block: "start", behavior: "instant" });
              this.updateThumbnail(e);
            },
          };
        }
        n.r(t),
          n.d(t, {
            default: function () {
              return o;
            },
          });
      },
      27: function (e, t, n) {
        "use strict";
        function r(e, t) {
          var n =
            ("undefined" != typeof Symbol && e[Symbol.iterator]) ||
            e["@@iterator"];
          if (!n) {
            if (
              Array.isArray(e) ||
              (n = (function (e, t) {
                if (!e) return;
                if ("string" == typeof e) return i(e, t);
                var n = Object.prototype.toString.call(e).slice(8, -1);
                "Object" === n && e.constructor && (n = e.constructor.name);
                if ("Map" === n || "Set" === n) return Array.from(e);
                if (
                  "Arguments" === n ||
                  /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
                )
                  return i(e, t);
              })(e)) ||
              (t && e && "number" == typeof e.length)
            ) {
              n && (e = n);
              var r = 0,
                o = function () {};
              return {
                s: o,
                n: function () {
                  return r >= e.length
                    ? { done: !0 }
                    : { done: !1, value: e[r++] };
                },
                e: function (e) {
                  throw e;
                },
                f: o,
              };
            }
            throw new TypeError(
              "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
            );
          }
          var s,
            a = !0,
            c = !1;
          return {
            s: function () {
              n = n.call(e);
            },
            n: function () {
              var e = n.next();
              return (a = e.done), e;
            },
            e: function (e) {
              (c = !0), (s = e);
            },
            f: function () {
              try {
                a || null == n.return || n.return();
              } finally {
                if (c) throw s;
              }
            },
          };
        }
        function i(e, t) {
          (null == t || t > e.length) && (t = e.length);
          for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
          return r;
        }
        function o() {
          return {
            options: { root: null, threshold: 1e-4 },
            observer: null,
            visibilityMap: new Map(),
            init: function () {
              this.observer = new IntersectionObserver(
                this.intersectObserver__itemVisibilityChanged.bind(this),
                this.options
              );
              var e,
                t = r(document.querySelectorAll(".product-intersect"));
              try {
                for (t.s(); !(e = t.n()).done; ) {
                  var n = e.value;
                  this.visibilityMap.set(n.classList[1], !0),
                    this.observer.observe(n);
                }
              } catch (e) {
                t.e(e);
              } finally {
                t.f();
              }
            },
            intersectObserver__itemVisibilityChanged: function (e, t) {
              var n = this;
              e.forEach(function (e) {
                n.visibilityMap.set(e.target.classList[1], e.isIntersecting);
                var t = Array.from(n.visibilityMap.values()).includes(!0);
                n.$el.classList.toggle("main--no-intersects", !t),
                  console.log("anyElementsVisible", t);
              });
            },
          };
        }
        n.r(t),
          n.d(t, {
            default: function () {
              return o;
            },
          });
      },
      219: function (e, t, n) {
        "use strict";
        function r() {
          return {
            handlers: new WeakMap(),
            options: { root: null, threshold: 0.3 },
            observer: null,
            init: function (e) {
              this.handlers.set(this.$el, e),
                (this.observer = new IntersectionObserver(
                  this.intersectObserver__itemVisibilityChanged.bind(this),
                  this.options
                )),
                this.observer.observe(this.$el),
                console.log("a");
            },
            intersectObserver__itemVisibilityChanged: function (e, t) {
              var n = this;
              e.forEach(function (e) {
                console.log("ab", e.isIntersecting);
                var t = n.handlers.get(e.target);
                e.isIntersecting
                  ? document.querySelector(t.element).classList.add(t.class)
                  : document.querySelector(t.element).classList.remove(t.class);
              });
            },
          };
        }
        n.r(t),
          n.d(t, {
            default: function () {
              return r;
            },
          });
      },
      191: function (e, t, n) {
        var r = {
          "./accordion.js": 17,
          "./address-form.js": 223,
          "./animated-reveal.js": 839,
          "./cart-count.js": 934,
          "./cart-section.js": 499,
          "./cart-tray.js": 37,
          "./collection-product.js": 506,
          "./mobile-menu.js": 25,
          "./product-form.js": 715,
          "./quote-form.js": 644,
          "./recently-viewed-products.js": 164,
          "./scroll-pagination.js": 294,
          "./search-form.js": 289,
          "./size-tray.js": 815,
          "./standard-product-images.js": 194,
          "./sticky-section.js": 7,
          "./toggle-class-on-child-intersect.js": 27,
          "./toggle-class-on-intersect.js": 219,
        };
        function i(e) {
          var t = o(e);
          return n(t);
        }
        function o(e) {
          if (!n.o(r, e)) {
            var t = new Error("Cannot find module '" + e + "'");
            throw ((t.code = "MODULE_NOT_FOUND"), t);
          }
          return r[e];
        }
        (i.keys = function () {
          return Object.keys(r);
        }),
          (i.resolve = o),
          (e.exports = i),
          (i.id = 191);
      },
      785: function (e, t, n) {
        "use strict";
        function r(e, t) {
          (null == t || t > e.length) && (t = e.length);
          for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
          return r;
        }
        function i(e) {
          return (
            (function (e) {
              if (Array.isArray(e)) return r(e);
            })(e) ||
            (function (e) {
              if (
                ("undefined" != typeof Symbol && null != e[Symbol.iterator]) ||
                null != e["@@iterator"]
              )
                return Array.from(e);
            })(e) ||
            (function (e, t) {
              if (e) {
                if ("string" == typeof e) return r(e, t);
                var n = Object.prototype.toString.call(e).slice(8, -1);
                return (
                  "Object" === n && e.constructor && (n = e.constructor.name),
                  "Map" === n || "Set" === n
                    ? Array.from(e)
                    : "Arguments" === n ||
                      /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
                    ? r(e, t)
                    : void 0
                );
              }
            })(e) ||
            (function () {
              throw new TypeError(
                "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
              );
            })()
          );
        }
        n.d(t, {
          Z: function () {
            return i;
          },
        });
      },
    },
    t = {};
  function n(r) {
    var i = t[r];
    if (void 0 !== i) return i.exports;
    var o = (t[r] = { exports: {} });
    return e[r].call(o.exports, o, o.exports, n), o.exports;
  }
  (n.n = function (e) {
    var t =
      e && e.__esModule
        ? function () {
            return e.default;
          }
        : function () {
            return e;
          };
    return n.d(t, { a: t }), t;
  }),
    (n.d = function (e, t) {
      for (var r in t)
        n.o(t, r) &&
          !n.o(e, r) &&
          Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    }),
    (n.g = (function () {
      if ("object" == typeof globalThis) return globalThis;
      try {
        return this || new Function("return this")();
      } catch (e) {
        if ("object" == typeof window) return window;
      }
    })()),
    (n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }),
    (n.r = function (e) {
      "undefined" != typeof Symbol &&
        Symbol.toStringTag &&
        Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }),
        Object.defineProperty(e, "__esModule", { value: !0 });
    }),
    (function () {
      "use strict";
      var e = n(592),
        t = n.n(e),
        r = {
          postParams: function (e) {
            return {
              method: "post",
              body: JSON.stringify(e),
              headers: { "Content-Type": "application/json" },
            };
          },
          polyfill: function (e, t) {
            return new Promise(function (n, r) {
              var i = new XMLHttpRequest(),
                o = [],
                s = [],
                a = {},
                c = function e() {
                  return {
                    ok: 2 == ((i.status / 100) | 0),
                    statusText: i.statusText,
                    status: i.status,
                    url: i.responseURL,
                    text: function () {
                      return Promise.resolve(i.responseText);
                    },
                    json: function () {
                      return Promise.resolve(JSON.parse(i.responseText));
                    },
                    blob: function () {
                      return Promise.resolve(new Blob([i.response]));
                    },
                    clone: e,
                    headers: {
                      keys: function () {
                        return o;
                      },
                      entries: function () {
                        return s;
                      },
                      get: function (e) {
                        return a[e.toLowerCase()];
                      },
                      has: function (e) {
                        return e.toLowerCase() in a;
                      },
                    },
                  };
                };
              for (var l in (i.open(t.method || "get", e, !0),
              (i.onload = function () {
                i
                  .getAllResponseHeaders()
                  .replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function (e, t, n) {
                    o.push((t = t.toLowerCase())),
                      s.push([t, n]),
                      (a[t] = a[t] ? a[t] + "," + n : n);
                  }),
                  n(c());
              }),
              (i.onerror = r),
              (i.withCredentials = "include" == t.credentials),
              t.headers))
                i.setRequestHeader(l, t.headers[l]);
              i.send(t.body || null);
            });
          },
          request: function (e) {
            var t = this,
              n =
                arguments.length > 1 && void 0 !== arguments[1]
                  ? arguments[1]
                  : { method: "get" };
            return fetch(e, n).then(function (r) {
              return r.ok || fetch === t.polyfill
                ? r
                : (console.log("set polyfill"),
                  (fetch = t.polyfill),
                  fetch(e, n));
            });
          },
          init: function () {
            ("fetch" in window && "function" == typeof fetch) ||
              (console.log("set polyfill"), (fetch = this.polyfill));
          },
          getText: function (e) {
            return this.request(e).then(function (e) {
              return e.text();
            });
          },
          getCartRaw: function () {
            return this.request("/cart.js");
          },
          getCart: function () {
            return this.request("/cart.js").then(function (e) {
              return e.json();
            });
          },
          addToCart: function (e) {
            var t =
                arguments.length > 1 && void 0 !== arguments[1]
                  ? arguments[1]
                  : {},
              n = { quantity: 1, id: e, properties: t };
            return this.request("/cart/add.js", this.postParams(n)).then(
              function (e) {
                return e.json();
              }
            );
          },
          addFormDataToCart: function (e) {
            return this.request("/cart/add.js", {
              method: "post",
              body: e,
            }).then(function (e) {
              return e.json();
            });
          },
          updateCart: function (e) {
            var t = { updates: e };
            return this.request("/cart/update.js", this.postParams(t)).then(
              function (e) {
                return e.json();
              }
            );
          },
          current_url: function () {
            return ""
              .concat(location.protocol, "//")
              .concat(location.host)
              .concat(location.pathname);
          },
          searchProducts: function (e) {
            return this.request("/search?q=".concat(e, "&view=json")).then(
              function (e) {
                return e.json();
              }
            );
          },
          getRemainingCollectionProducts: function (e) {
            var t = e ? "remaining_offset" : "remaining";
            return this.request(
              "".concat(this.current_url(), "?view=").concat(t)
            ).then(function (e) {
              return e.text();
            });
          },
          graphQLRequestUrl: function () {
            return "https://".concat(
              location.host,
              "/api/2021-10/graphql.json"
            );
          },
          graphQLPostPayload: function (e) {
            return {
              method: "post",
              body: JSON.stringify(e),
              headers: {
                "Content-Type": "application/json",
                "X-Shopify-Storefront-Access-Token": window.STORE.TOKEN,
              },
            };
          },
          graphQLPostRequest: function (e) {
            return fetch(
              this.graphQLRequestUrl(),
              this.graphQLPostPayload(e)
            ).then(function (e) {
              return e.json();
            });
          },
        },
        i = {
          money: function (e) {
            var t =
              arguments.length > 1 && void 0 !== arguments[1]
                ? arguments[1]
                : 2;
            return (
              this.moneyWithoutCurrency(e, t) + " " + window.STORE.currency_code
            );
          },
          moneyWithoutCurrency: function (e) {
            var t =
              arguments.length > 1 && void 0 !== arguments[1]
                ? arguments[1]
                : 2;
            return (
              window.STORE.currency_symbol +
              (e / 100).toLocaleString("en-US", {
                minimumFractionDigits: t,
                maximumFractionDigits: t,
              })
            );
          },
          resizeImage: function (e) {
            var t =
              arguments.length > 1 && void 0 !== arguments[1]
                ? arguments[1]
                : 200;

            if (!e || typeof e !== "string") return "";

            return e.replace(/\.(jpg|jpeg|png|webp)(\?.*)?$/i, function(match, ext, query) {
              return "_" + t + "x" + t + "." + ext + (query || "");
            });
          },
          scrollToNextChild: function (e, t) {
            var n = e.getBoundingClientRect();
            console.log("scrollToNextChild", e.scrollLeft, n.left);
            var r = e.children.item(0).getBoundingClientRect(),
              i = Math.round(e.scrollLeft / r.width) + t;
            if (
              (console.log(
                "ii",
                e.scrollLeft,
                r.width,
                e.scrollLeft / r.width,
                Math.round(e.scrollLeft / r.width)
              ),
              console.log("index", i),
              i >= 0 && i < e.children.length)
            ) {
              var o = e.children.item(i).getBoundingClientRect();
              e.scroll({
                left: o.left - n.left + e.scrollLeft,
                behavior: "smooth",
              });
            }
          },
          scrollToNextChildVertical: function (e, t) {
            var n = e.getBoundingClientRect(),
              r = e.children.item(0).getBoundingClientRect(),
              i = Math.round(e.scrollTop / r.height) + t;
            if (i >= 0 && i < e.children.length) {
              var o = e.children.item(i).getBoundingClientRect();
              e.scroll({
                top: o.top - n.top + e.scrollTop,
                behavior: "smooth",
              });
            }
          },
          checkIfUrlParamExists: function (e, t) {
            null !== new URLSearchParams(window.location.search).get(t) &&
              (e.checked = !0);
          },
          checkIfUrlContains: function (e, t) {
            window.location.href.includes(t) && (e.checked = !0);
          },
        };
      function o(e, t) {
        var n =
          ("undefined" != typeof Symbol && e[Symbol.iterator]) ||
          e["@@iterator"];
        if (!n) {
          if (
            Array.isArray(e) ||
            (n = (function (e, t) {
              if (!e) return;
              if ("string" == typeof e) return s(e, t);
              var n = Object.prototype.toString.call(e).slice(8, -1);
              "Object" === n && e.constructor && (n = e.constructor.name);
              if ("Map" === n || "Set" === n) return Array.from(e);
              if (
                "Arguments" === n ||
                /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
              )
                return s(e, t);
            })(e)) ||
            (t && e && "number" == typeof e.length)
          ) {
            n && (e = n);
            var r = 0,
              i = function () {};
            return {
              s: i,
              n: function () {
                return r >= e.length
                  ? { done: !0 }
                  : { done: !1, value: e[r++] };
              },
              e: function (e) {
                throw e;
              },
              f: i,
            };
          }
          throw new TypeError(
            "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
          );
        }
        var o,
          a = !0,
          c = !1;
        return {
          s: function () {
            n = n.call(e);
          },
          n: function () {
            var e = n.next();
            return (a = e.done), e;
          },
          e: function (e) {
            (c = !0), (o = e);
          },
          f: function () {
            try {
              a || null == n.return || n.return();
            } finally {
              if (c) throw o;
            }
          },
        };
      }
      function s(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
        return r;
      }
      Spruce.persistUsing(window.sessionStorage),
        Spruce.store(
          "cartStore",
          {
            show_size_tray: !1,
            show_cart_tray: !1,
            show_loading_item: !1,
            size_country_selection: "usa",
            selected_variant: {},
            extra_option_0: "",
            extra_option_1: "",
            extra_option_2: "",
            extra_option_3: "",
            add_valuation: "",
            cart: {},
            viewed_product_count: 0,
            has_product_pagination_been_clicked: !1,
            show_quote_form: !1,
            get items() {
              return this.cart.items;
            },
            init: function () {
              (this.show_cart_tray = !1),
                (this.show_size_tray = !1),
                (this.show_quote_form = !1),
                (this.cart = window.STORE.cart),
                console.log("init cart", this.cart),
                window.STORE.product_variants &&
                  ((this.add_valuation = ""),
                  (this.selected_variant = window.STORE.product_variants.find(
                    function (e) {
                      return e.available;
                    }
                  )),
                  null == this.selected_variant &&
                    (this.selected_variant = window.STORE.product_variants[0]));
            },
            fetchCart: function () {
              var e = this;
              return r
                .getCart()
                .then(function (t) {
                  e.show_loading_item = !1;
                  var n,
                    r = t,
                    i = o(r.items);
                  try {
                    var s = function () {
                      var t = n.value;
                      t.isNew = !e.cart.items.some(function (e) {
                        return e.variant_id === t.variant_id;
                      });
                    };
                    for (i.s(); !(n = i.n()).done; ) s();
                  } catch (e) {
                    i.e(e);
                  } finally {
                    i.f();
                  }
                  (e.cart = r), e.stopProgress();
                })
                .catch(function (t) {
                  console.error('Cart fetch failed:', t);
                  e.show_loading_item = !1;
                  e.stopProgress();
                });
            },
            addToCart: function (e) {
              var t = this,
                n =
                  arguments.length > 1 && void 0 !== arguments[1]
                    ? arguments[1]
                    : {};
              this.showProgress(),
                (this.show_cart_tray = !0),
                (this.show_loading_item = !0),
                r.addToCart(e, n).then(function (e) {
                  (new Image().src = Utils.resizeImage(e.image, 600)),
                    t.fetchCart(!0);
                });
              //var i = window._learnq || [];
              //i.push(["track", "Added to Cart", { id: e, quantity: 1 }]);
            },
            addFormDataToCart: function (e) {
              var t = this;
              (this.show_cart_tray = !0),
                (this.show_loading_item = !0),
                this.showProgress(),
                r.addFormDataToCart(e).then(function (e) {
                  (new Image().src = Utils.resizeImage(e.image, 600)),
                    t.fetchCart(!0);
                });
              //removed klaviyo tracking ,(window._learnq || []).push(["track", "Added to Cart", { id: e.get("id"), quantity: 1 }]);
            },
            updateCart: function (e) {
              var t = this;
              this.showProgress(),
                r.updateCart(e).then(function (e) {
                  (t.cart = e), t.stopProgress();
                });
            },
            showProgress: function () {},
            stopProgress: function () {},
            setProductViewed: function () {
              this.viewed_product_count++;
            },
          },
          !0
        );
      n(443);
      (window.Utils = i), (window.Api = r), (window.Component = {});
      var a = n(191);
      a.keys().forEach(function (e) {
        var t = e
          .replace(/\.(\/|js)/g, "")
          .replace(/(\/|-|_|\s)\w/g, function (e) {
            return e.slice(1).toUpperCase();
          });
        window.Component[t] = a(e).default;
      }),
        window.Api.init(),
        t().store("cartStore").init(),
        document.addEventListener("DOMContentLoaded", function (e) {
          document.querySelectorAll("[open-chat]").forEach(function (e) {
            e.addEventListener("click", function (e) {
              window.tidioChatApi.show(), window.tidioChatApi.open();
            });
          }),
            document
              .querySelectorAll("[open-size-guide]")
              .forEach(function (e) {
                e.addEventListener("click", function (e) {
                  t().store("cartStore").show_size_tray = !0;
                });
              });
        });
    })();
})();
function bisToggle() {
  let b = document.getElementById("ns-bis-emailcapture");
  if (b) {
    b.classList.add("show-bis-capture");
  }
}
function bisRegister(va) {
  let em = document.getElementById("bisemail").value.trim();
  if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(em)) {
    registerBIS(em, va);
  } else {
    alert("Please ensure the provided email address is correct.");
  }
}
async function registerBIS(em, va) {
  console.log(em);
  const biso = {
    method: "POST",
    headers: {
      accept: "application/json",
      revision: "2023-09-15",
      "content-type": "application/json",
    },
    body: JSON.stringify({
      data: {
        type: "back-in-stock-subscription",
        attributes: {
          channels: ["EMAIL"],
          profile: { data: { type: "profile", attributes: { email: em } } },
        },
        relationships: {
          variant: {
            data: {
              type: "catalog-variant",
              id: "$shopify:::$default:::" + va,
            },
          },
        },
      },
    }),
  };
  const re = await fetch(
    "https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=WzkzXu",
    biso
  );
  if (!re.ok) {
    throw new Error(`HTTP error! status: ${re.status}`);
  } else {
    let button = document.getElementById("klaviyo-bis-action");
    button.innerHTML = "Submitted";
    button.style.backgroundColor = "#898685";
    button.style.color = "#fff";
    button.disabled = true;
  }
}
